import React from "react";
import { observable } from "mobx";
import AgendamentoContainerService from "../../../../services/AgendamentoContainerService";
import _ from 'lodash';
import lscache from 'lscache';
import moment from 'moment';
import { arrayIsEmpty } from '../../../../utils/functions';

import { isInvalidoCodigoContainer, isInvalidoPlacas, isNotAlphanumeric } from "../../../../utils/validadores";
import { LegendaNormalCirculo, LegendaGoldCirculo, LegendaEsgotadoCirculo, LegendaIndisponivelCirculo } from "../../../comum/components/Legenda";
import { formatarListaDatas, formatarListaHoras, formatarListaHorasDeadLine, splitBR } from "../../../../utils/formatar";
import { createPDFDetalhesAgendamento } from "../../../../utils/pdfDetalhesAgendamento";

export default class AgendamentoCadastrarStore {

    @observable tudoPronto;
    @observable isEditar;
    agendId;
    dadosAgendamentoPronto;
    dadosMotoristaPronto;
    dadosContainersPronto;
    dadosNotasPronto;
    @observable tipoCadastroImportacaoEntrada;
    @observable dadosAgendamento;
    @observable containersOptions;
    @observable dadosNotaFiscal;
    @observable listaContainersOptions;
    @observable containersSelecionados;

    @observable notaFiscalNObrigatoria;
    @observable tranAduaneiro;

    @observable abaEntradaAtiva;

    @observable terminal;
    @observable tiposAgenda;
    @observable tipoAgendaAtivo;
    @observable tipoAgendaRetirada;
    tiposAgendaRetirada;
    @observable tipoAgendaEntrada;
    tiposAgendaEntrada;
    @observable tipoEntradaImportacaoDepot;
    tiposEntradaImportacaoDepot;
    @observable tipoAgendaDesistencia
    tiposAgendaDesistencia

    @observable mostraNfNaoObrigatoria;

    @observable padraoDeCodigoInvalido;
    @observable objetoDeNotaFiscalNaoObrigatoria;

    // Geral
    @observable categoriasCnh;
    @observable transportadoras;
    @observable motoristas;

    @observable listaHoras;
    @observable listaDatas;
    @observable transportadorasNotaFiscal;
    @observable modalCarregarDoc;

    // Bookings
    @observable operacoes;
    @observable erroBookingTerminal;
    //
    @observable documentosRetirada;
    @observable dadoDocumentoSelecionado;

    @observable atualiza;
    @observable atualizaData;
    @observable atualizaBookings;
    @observable HaveraNotaFiscalNaoObrigatoria;
    @observable atualizaRetiradas;
    @observable atualizaDevolucoes;
    @observable atualizaLacres;
    @observable atualizaNotas;
    @observable atualizaNotasFiscais;
    @observable atualizaNotasFiscaisContainer;
    
    // Adicionar por modais
    @observable mostrarInserirNovo;
    @observable inserindoEmModal;
    @observable codigoNovo;
    @observable codigoBooking;
    @observable outrosTextError;

    posBookingNovoContainer;
    posNotaFiscalNovoContainer;

    @observable codigoNovoImportacao;
    @observable codigoContainerImportacao;
    containerNovoImportacao;


    @observable listaMensagens;

  @observable salvar;
  @observable apareceModalDeExclusao; 
  @observable apareceModal;
  camposObrigatorios;
  camposValidados;
  @observable modalConfirmacaoCargaReefer;
  @observable modalFimAgendamento;
  @observable modalFimNotaFiscal;
  @observable resultadoFimAgendamento;
  @observable resultadoFimNotasFiscais;
  @observable corrigirNotasFiscais;
  camposObrigatoriosNotas;
  @observable validacaoNotaOffline;

    @observable validandoXML;
    @observable erroImportXML;
    @observable erroImportXMLMensagem;
    xmlFileData;
    @observable jsonFile;

    @observable validado
    @observable  bloqueiaCamposMotoristaCat;
    @observable  bloqueiaCamposMotoristaNome;
    @observable  bloqueiaCamposMotoristaCpf;

    @observable terminal
    //A variável abaixo foi definida para que possa ser feita a busca do terminal com mais segurança, depois que foi pedida a não obrigatoriedade em SSA
    @observable terminalObrigatorios;
    @observable blurStatus;
    @observable contadorDoFor;
    
    @observable listaBookingsAnterior;
    @observable recarregarBooking;
    @observable containersEdicao;
    @observable tipoDoArquivo;
    @observable idDoArquivo;
    @observable ContainersNotaFiscalNaoObrigatoria;
    @observable ValidarCampoOutros;

    @observable exibeAlertaBookingNotas;
    @observable alertaBookingNotas;
    @observable listaNotasAssociadas;
    @observable loadNotasAssociadas;

    @observable alertaSSA;
    
    isDepot;

  constructor() {
    this.contadorDoFor = 0;
    this.tudoPronto = false;
    this.agendId = false;
    this.dadosAgendamentoPronto = false;
    this.dadoDocumentoSelecionado = false;
    this.objetoDeNotaFiscalNaoObrigatoria = {
      observacoes: "",
      outros: "",
      isCheckedBagagem: false,
      isCheckedVazio: false,
      isCheckedOutros: false,
      fileNota: [],
    };
    this.HaveraNotaFiscalNaoObrigatoria = false;
    this.CnpjClienteNota = [];
    this.NotaFiscalNaoObrigatoria = {
      NotaId: "",
      ObservacoesValue: "",
      OutrosValue: "",
      validarOutros: false,
      IsCheckedBagagemValue: "",
      IsCheckedVazioValue: "",
      AgendaId: 0,
      Email: "",
      Booking: "",
      Navio: "",
      CnpjClienteNota: "",
      ContainerNotaNaoObrigatoria: "",
      ChaveDeAcesso: "",
      IdsDosArquivosReferenteAoAgendamento: [],
    };
    this.ValidarCampoOutros = false;
    this.ContainersNotaFiscalNaoObrigatoria = [];
    this.apareceModalDeExclusao = false;
    this.tipoDoArquivo = {};
    this.idDoArquivo = {};
    this.carregandoContaineres = {};
    this.dadoContainerSelecionado = false;
    this.tipoCadastroImportacaoEntrada = "";
    this.dadosAgendamento = {};
    this.dadosNotaFiscal = { listaNf: [] };
    this.containersOptions = [];
    this.listaContainersOptions = [];
    this.containersSelecionados = [];
    this.modalCarregarDoc = false;
    this.terminal = false;
    this.tiposAgenda = [];
    this.tipoAgendaAtivo = false;
    this.abaEntradaAtiva = "0";
    this.tiposAgendaEntrada = ["ECC", "ECV", "23ECV", "ECTA", "ECR", "ECRTA", "ECE", "ECT", "ECCM", "ECVB", "EUA", "ECDL"];
    this.tipoAgendaEntrada = -1;
    this.tiposAgendaRetirada = [
      "RCV",
      "23RCV",
      "RCDTC",
      "RCDICTAC",
      "RCDTA",
      "RCCRP",
      "RVI",
      "RVB",
      "RDVD",
      "SPN",
      "RECBK"
    ];
    this.tipoAgendaRetirada = -1;
    this.tiposAgendaDesistencia = ["DE", "RDEC"];
    this.tipoAgendaDesistencia = -1;
    this.tiposAgendaRetiradaDepot = ["DRE"];
    this.tipoAgendaRetiradaDepot = -1;
    this.tiposAgendaRetiradaDepotDry = ["DRED"];
    this.tipoAgendaRetiradaDepotDry = -1;
    this.tiposAgendaRetiradaDevolucao = ["DDI"];
    this.tipoAgendaRetiradaDevolucao = -1;
    this.tiposAgendaRetiradaDepotDryAlimento = ["DREDA"];
    this.tipoAgendaRetiradaDepotDryAlimento = -1;
    this.tiposEntradaImportacaoDepot = ["DREDD"];
    this.tipoEntradaImportacaoDepot = -1;
    this.tiposAgendaEntradaCheio = ["ECC", "ECDL", "ECR"];


        this.isDepot = false;

        this.padraoDeCodigoInvalido = false;

        // Geral
        this.categoriasCnh = [];
        this.transportadoras = [];
        this.motoristas = [];

        this.listaHoras = [];
        this.listaDatas = [];
        this.transportadorasNotaFiscal = [];

        // Bookings
        this.operacoes = [];
        this.erroBookingTerminal = false;
        this.salvando = false;
        this.aguardandoSalvar = false;
        this.achouErro = false;
        this.indexComProblemas = [];


        this.atualiza = false;
        this.atualizaData = true;
        this.atualizaBookings = false;
        this.atualizaRetiradas = false;
        this.atualizaDevolucoes = false;
        this.atualizaLacres = true;
        this.atualizaNotasFiscais = false;
        this.atualizaNotasFiscaisContainer = false;
        this.atualizaNotas = true;

        this.mostrarInserirNovo = "";
        this.inserindoEmModal = false;
        this.codigoNovo = "";
        this.codigoBooking = "";

        this.listaMensagens = false;

        this.notaFiscalNObrigatoria = false;
        this.tranAduaneiro = false;

        this.salvar = false;
        this.modalConfirmacaoCargaReefer = false;
        this.modalFimAgendamento = false;
        this.modalFimNotaFiscal = false;
        this.resultadoFimAgendamento = false;
        this.resultadoFimNotasFiscais = false;
        this.corrigirNotasFiscais = false;
        this.validacaoNotaOffline = true;

        this.service = new AgendamentoContainerService();

        this.xmlFileData = "";
        this.jsonFile = null;
        this.validandoXML = false;
        this.erroImportXML = false;
        this.erroImportXMLMensagem = "";
        this.mensagemErroPadrao = "Ocorreu um erro. Tente novamente mais tarde.";
        this.alertaSSA = true;

        this.validado = true //acredito que a melhor forma para incializar seja como true, pois nada foi efetivamente validado ainda
        this.validadoLacres = true

        this.camposZerados = ["Id", "Operacao", "CodCfop", "Membershipuserid", "TruckVisitAppointmentNbr"];
        this.dadosAgendamentoAceitaEspaco = ["Motorista.Nome", "RazSocialCliente", "RazSocialRespOva","Nf.RazaoSocialDest", "Nf.NomCidadeDest"];
        this.camposNulos = ["NumBooking", "FlagBagagem", "Ruc", "StatusDue", "FlagBitrem", "XmlNota", "NomCidadeDest",];
        this.dadosMercadoria = {}

        this.handleBlurBooking = this.handleBlurBooking.bind(this);
        this.handleBlurContainer = this.handleBlurContainer.bind(this);
        this.carregarCamposPorNovoBooking = this.carregarCamposPorNovoBooking.bind(this);
        this.collapseBookings = this.collapseBookings.bind(this);
        this.collapseNotaFiscal = this.collapseNotaFiscal.bind(this);
        this.atualizaNotasContainer = this.atualizaNotasContainer.bind(this);
        this.formatarContainersSelecionado = this.formatarContainersSelecionado.bind(this);
        this.setDadosNotaFiscal = this.setDadosNotaFiscal.bind(this);

        this.bookingBlur = false;
        this.containerBlur = false;
        this.blurStatus = false;

        this.novoContainerBooking = "";
        this.novoContainerImportacao = "";
        this.novoContainerIndex = 1;

        this.tipoAgendaAnterior = {};
        this.listaBookingsAnterior = {};
        this.recarregarBooking = false;

        this.containersEdicao = [];

        this.exibeAlertaBookingNotas = null;
        this.alertaBookingNotas = [];
        this.listaNotasAssociadas = [];
        this.loadNotasAssociadas = false;

        this.bloqueiaCamposMotoristaCat = true;
        this.bloqueiaCamposMotoristaNome = true;
        this.bloqueiaCamposMotoristaCpf = true;

        this.setDadosAgendaAnterior = this.setDadosAgendaAnterior.bind(this);
        this.inserirNotasAssociadas = this.inserirNotasAssociadas.bind(this);

        this.novoAgendamento = {};

        this.cdCntrReefer = [];

        this.cnpjtransp = 0;
    };

    validarContainerBookingNotas = async () => {
        const notas = this.dadosNotaFiscal.listaNf;
        const bookings = this.dadosAgendamento.listaBookings;
        let validaContainers = [];
        let exibeAlertaSobrando = false;
        let exibeAlertaValido = false;
        let verificarNota = [];
        let encontrou = null;
        let totalCntrBooking = 0;
        let totalCntrNota = 0;
        let cntrSobrandoNota = []; //containers que possuem nota, mas não estão no agendamento
        this.exibeAlertaBookingNotas = encontrou;

        //Valida se existem containers
        if (bookings && bookings.length > 0) {
            bookings.map((bookAgend, x) => {
                if (bookAgend.containers && bookAgend.containers.length > 0) {
                    //Total de containers
                    totalCntrBooking = totalCntrBooking + bookAgend.containers.length;
                    //gerando array auxiliar
                    validaContainers[x] = { containers: [] };
                    //Valores iniciais
                    bookAgend.containers.map((cntr, c) => {
                        var nomeContainer = cntr.CodCntr === "" || !cntr.CodCntr ? "[SEM NÚMERO " + c + "]"  : cntr.CodCntr.toUpperCase();
                        var nomeBooking = !bookAgend.NumBooking || bookAgend.NumBooking === "" ? "[SEM NÚMERO " + x + "]"  : bookAgend.NumBooking.toUpperCase();
                        validaContainers[x].containers.push({ CodCntr: nomeContainer, CodBooking: nomeBooking, encontrado: false });
                    });
                }
            });
        }
        else
            return encontrou

        if (notas && notas.length > 0) {
            //Total de containers da Nota            
            notas.map(nota => {
                totalCntrNota = totalCntrNota + nota.ListaCntr.length;
            });

            bookings.map((bookAgend, b) => {
                if (bookAgend.containers && bookAgend.containers.length > 0) {
                    encontrou = false;
                    bookAgend.containers.map((cntrAgend, x) => {
                        if (bookAgend.NumBooking) {
                            notas.map((nota, n) => {
                                if (nota.ListaCntr && nota.ListaCntr.length > 0) {
                                    nota.ListaCntr.map((cntrNF, c) => {
                                        let notaNumBooking = cntrNF.NumBooking;
                                        if (!notaNumBooking)
                                            notaNumBooking = "";
                                        let notaContainer = cntrNF.CodCntr;
                                        if (!notaContainer)
                                            notaContainer = "";
                                        let agendBooking = bookAgend.NumBooking;
                                        if (!agendBooking)
                                            agendBooking = "";
                                        let agendContainer = cntrAgend.CodCntr;
                                        if (!agendContainer)
                                            agendContainer = "";

                                        //Só registrar mensagem de cntr sobrando na Nota se o cliente já tiver digitado (!== "")
                                        if (notaContainer !== ""){
                                            if (notaContainer.toUpperCase() === agendContainer.toUpperCase()){
                                                var nomeContainer = notaContainer === "" ? "[SEM NÚMERO " + c + "]"  : notaContainer.toUpperCase();
                                                cntrSobrandoNota = cntrSobrandoNota.filter(item => item.CodCntr != nomeContainer);
                                            } else {
                                                var nomeContainer = notaContainer === "" ? "[SEM NÚMERO " + c + "]"  : notaContainer.toUpperCase();
                                                var numNota = nota.Nf && nota.Nf.NumNotaTransp === "" ? "[SEM NÚMERO " + n + "]"  : nota.Nf.NumNotaTransp.toUpperCase();
                                                cntrSobrandoNota = cntrSobrandoNota.filter(item => item.CodCntr != nomeContainer);
                                                cntrSobrandoNota.push({CodCntr : nomeContainer, CodBooking: notaNumBooking.toUpperCase(), NumNota: numNota});
                                            }
                                        }

                                        if (notaContainer.toUpperCase() === agendContainer.toUpperCase() &&
                                            notaNumBooking.toUpperCase() === agendBooking.toUpperCase()) {
                                            encontrou = true;
                                            if (!validaContainers[b].containers[x].encontrado)
                                                validaContainers[b].containers[x].encontrado = true
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }

        if (totalCntrBooking > 0 && totalCntrNota === 0) {
            //exibeAlerta = true;
            //encontrou = false;
            //this.alertaBookingNotas = [];
            //this.alertaBookingNotas.push("Agendamento sem Nota Fiscal de Transporte associada.");
        } else {
            if (totalCntrBooking > 0 && totalCntrNota > 0) {
                this.alertaBookingNotas = [];
                if (validaContainers && validaContainers.length > 0) {
                    validaContainers.map((bookAgend, v) => {
                        if (validaContainers[v].containers && validaContainers[v].containers.length > 0) {
                            validaContainers[v].containers.map(valida => {
                                if (!valida.encontrado){
                                    exibeAlertaValido = true;
                                    verificarNota.push({ key: valida.CodCntr, value: valida.CodBooking });
                                    this.alertaBookingNotas.push("Container " + valida.CodCntr + " do Booking " + valida.CodBooking + " do Agendamento não possui Nota Fiscal vinculada.");
                                } else {
                                    //Remover da lista de cntrs sobrando da nota, caso tenha sido encontrado
                                    cntrSobrandoNota = cntrSobrandoNota.filter(item => item.CodCntr != valida.CodCntr);
                                }
                            });
                        }
                    });
                }

                if(cntrSobrandoNota && cntrSobrandoNota.length > 0) {
                    exibeAlertaSobrando = true;
                    cntrSobrandoNota.map((cntr, v) => {
                        this.alertaBookingNotas.push("Container " + cntr.CodCntr + " e Booking " + cntr.CodBooking + " informado na Nota Fiscal não está no Agendamento.");
                    });
                }
            }
        }

        if(verificarNota.length > 0) {
            await this.service.ListarNotasPorCntrBooking(verificarNota).then(res => {
                if(res && res.data && res.data.length > 0) {
                    const containersComNota = res.data.map(nota => nota.ListaCntr.map(cntr => ({CodCntr: cntr.CodCntr, CodBooking: cntr.NumBooking}))).flat();
                    this.removeAlertaCntr(containersComNota);
                    if(this.procuraContainersComNota(containersComNota, verificarNota)) {
                        exibeAlertaValido = false;
                    }
                }
            });
        }

        if (encontrou != null && (exibeAlertaValido || exibeAlertaSobrando)){
            this.exibeAlertaBookingNotas = true;
        } else {
            this.exibeAlertaBookingNotas = null;
        }

        return encontrou;
    }

    removeAlertaCntr = (listaContainers = []) => {
        listaContainers.forEach(cntr => {
            this.alertaBookingNotas = this.alertaBookingNotas.filter(alerta => !alerta.includes(cntr.CodCntr) && !alerta.includes(cntr.CodBooking));
        });
    }


    procuraContainersComNota = (containersComNota = [], listaContainers = []) => {
        listaContainers.forEach(cntr => {
            if(containersComNota.find(cntrNota => cntrNota.CodCntr === cntr.CodCntr && cntrNota.CodBooking === cntr.CodBooking) === undefined) {
               return false;
            }
        });
        return true;
    }

    fechaAlerta = () => {
        this.alertaSSA = false
    }
    

    setDadosAgendaAnterior = (dadosAgendaAnterior) => {
        this.dadosAgendamento = {};
        _.set(this.dadosAgendamento, `listaBookings`, dadosAgendaAnterior.listaBookings);

        if (this.dadosAgendamento.listaBookings)
            this.dadosAgendamento.listaBookings.map((book, x) => {
                this.dadosAgendamento.listaBookings[x].containers = [];
            });
    }

    iniciaEdicao = (id, mudaTipoAgendamento) => {
        this.atualiza = false;
        this.atualizaBookings = false;
        this.atualizaRetiradas = false;
        this.atualizaDevolucoes = false;
        this.atualizaNotasFiscais = false;

        this.carregarAgendamentoPorId(id, mudaTipoAgendamento);
        this.carregarContainersPorAgendaId(id);

    //TODO - Após o go live, removemos a funcionalidade de notas fiscais no agendamento para RIG
    if (!process.env.rig) {
      this.carregarNotasFiscaisPorAgendaId(id);
    } else {
      //Para que funcione, foi preciso adicionar esse controle para dizer que a tela já carregou por completo
      this.dadosNotasPronto = true;
    }
  };
  visualizarDocumento = (idDocumento) => {
    if (idDocumento != null && idDocumento != undefined) {
      var teste = this.service.buscarDocumento(idDocumento);
      window.open(teste);
    } else {
      this.listaMensagens = ["Ocorreu um problema ao baixar o documento"];
    }
  };
  excluirArrayDaNota = (idObject) => {
    if (
      this.objetoDeNotaFiscalNaoObrigatoria.fileNota != null &&
      this.objetoDeNotaFiscalNaoObrigatoria.fileNota != undefined
    ) {
      this.objetoDeNotaFiscalNaoObrigatoria.fileNota.map((c, index) => {
        if (c.FileId == idObject) {
          this.objetoDeNotaFiscalNaoObrigatoria.fileNota.splice(index, 1);
        }
      });
    }
    if (
      this.NotaFiscalNaoObrigatoria.IdsDosArquivosReferenteAoAgendamento !=
        null &&
      this.NotaFiscalNaoObrigatoria.IdsDosArquivosReferenteAoAgendamento !=
        undefined
    ) {
      this.NotaFiscalNaoObrigatoria.IdsDosArquivosReferenteAoAgendamento.map(
        (c, index) => {
          if (c == idObject) {
            this.NotaFiscalNaoObrigatoria.IdsDosArquivosReferenteAoAgendamento.splice(
              index,
              1
            );
          }
        }
      );
    }
  };
  excluirDocumentoNota = async (notaId) => {
  try {
    if (notaId != null && notaId != undefined) {
      return await this.service
        .excluirDocumentoNotaNaoObrigatoria(notaId)
        .then((response) => {
          if (response) {
            if (!response.data.Sucesso) {
              this.listaMensagens = response.data.Mensagens || ["Erro ao excluir o arquivo."];
            } else {
              this.excluirArrayDaNota(notaId);
              this.listaMensagens = ["Arquivo excluído com sucesso."];
              this.objetoDeNotaFiscalNaoObrigatoria.fileNota = []; // limpa arquivos anteriores
            }
          } else {
            this.listaMensagens = ["Ocorreu um problema ao excluir o arquivo"];
          }
        })
        .catch((error) => {
          console.log(error);
          this.listaMensagens = ["Erro de conexão com o servidor"];
        });
    } else {
      this.listaMensagens = ["Ocorreu um problema ao excluir o arquivo"];
    }
  } catch (error) {
    console.log(error);
    this.listaMensagens = ["Erro inesperado"];
  }
};


  
  salvarArquivoNotaNaoObrigatoria = async (objetoNota) => {
    try {
      if (
        objetoNota.NomeDoArquivo != null &&
        objetoNota.NomeDoArquivo != undefined
      ) {
        let data = new FormData();
        data.append("file", objetoNota.Arquivo);
        return await this.service
          .salvarDocumentoNotaFiscal(data, objetoNota.NomeDoArquivo, objetoNota.agendaId)
          .then((response) => {
            if (response) {
              if (!response.data.Sucesso) {
                this.listaMensagens = response;
              } else {
                this.contadorDoFor++;
                const newFileNota = {
                  NomeDoArquivo: objetoNota.NomeDoArquivo,
                  dataEhoraEmQueFoiFeitoUpload:
                    objetoNota.dataEhoraEmQueFoiFeitoUpload,
                  FileId: response.data.Mensagem.split(":").pop(),
                };
                this.objetoDeNotaFiscalNaoObrigatoria.fileNota.push(
                  newFileNota
                );
                this.NotaFiscalNaoObrigatoria.IdsDosArquivosReferenteAoAgendamento.push(
                  newFileNota.FileId
                );
              }
            } else {
              this.listaMensagens = ["Ocorreu um problema ao salvar o arquivo"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.listaMensagens = ["Ocorreu um problema ao salvar o arquivo"];
      }
    } catch (error) {
      console.log(error);
    }
  }; 

    carregarAgendamentoPorId = (id, mudaTipoAgendamento) => {
        this.agendId = id;
        this.service.buscarAgendamentoPorId(id).then(response => {
            if (response.data) {
                this.dadosAgendamento.Agend = response.data;
                if (this.dadosAgendamento.Agend.Cnh) _.set(this.dadosAgendamento, 'Motorista.N4DriverLicense', this.dadosAgendamento.Agend.Cnh.toString());

                this.dadosAgendamento.Agend.DatAgend = this.dadosAgendamento.Agend.DatAgend;

                this.carregarMotoristaPorCNH();
                this.carregarDATPorAgenda(this.agendId);
                this.dadosAgendamentoPronto = true;
                this.carregaAgendamentoCompleto();

                this.carregaTipoAgendaPorId(response.data.TipoAgendId);
                mudaTipoAgendamento(response.data.TipoAgendId);
            } else {
                this.listaMensagens = response;
            }
        }).catch(error => {
            console.log(error);
        })
    };

    carregarContainersPorAgendaId = (id) => {
        let flgNaoNota = false;
        this.service.buscarContainersPorAgenda(id).then(response => {
            if (response.data) {
                if (response.data && response.data.length > 0) {
                    response.data.map(cntr => {
                        if (cntr.FlgNaoNota === "S")
                            flgNaoNota = true;
                    });
                    this.notaFiscalNObrigatoria = flgNaoNota;
                }
                _.set(this.dadosAgendamento, `listaBookings`, this.service.parseBookings(response.data));
                this.dadosContainersPronto = true;
                this.carregarLacresPorAgendaContainerId();
            } else {
                this.listaMensagens = response;
            }
        }).catch(error => {
            console.log(error);
        })
    };

    carregarLacresPorAgendaContainerId = () => {
        if (this.dadosAgendamento.listaBookings != null) {
            this.dadosAgendamento.listaBookings.forEach(book => {
                if (book.containers != null) {
                    book.containers.forEach(cntr => {
                        this.service.buscarLacresPorAgendaContainerId(cntr.Id).then(response => {
                            if (response.data) {
                                let lacres = response.data;
                                lacres.forEach(lcr => {
                                    cntr.Lacres.push({ "Id": lcr.Id, "CdLacre": lcr.CdLacre, "Lacre": lcr.Lacre, "AgendCntrId": lcr.AgendCntrId });
                                });
                            } else {
                                cntr.Lacres = null;
                            }
                        })
                    });
                }
            });
        };
    };

    carregaAgendamentoCompleto = () => {
        if (this.dadosAgendamentoPronto && this.dadosContainersPronto && this.dadosNotasPronto) {
            console.log('ta entrando?')
            this.tudoPronto = true;
            setTimeout(function () {
                this.atualiza = true;
                this.atualizaBookings = true;
                this.atualizaRetiradas = true;
                this.atualizaNotasFiscais = true;
            }.bind(this), 1)
        } else {
            setTimeout(function () {
                this.carregaAgendamentoCompleto();
            }.bind(this), 300)
        }

        this.validarContainerBookingNotas();
    };

    carregarTiposAgendamentos = () => {
        this.tiposAgenda = [];
        this.service.listarTipoAgendamento().then(response => {
            var options = [];
            if (response.data) response.data.map(e => {
                options.push({ value: e.Id, label: e.DscTipo, codIdentificador: e.CodIdentificador, codTipo: e.CodTipo })
            });
            this.tiposAgenda = options;
        }).catch(error => {
            console.log(error);
        })
    };

    carregarCategoriasCNH = () => {
        this.service.listarCategoriasCNH().then(response => {
            this.categoriasCnh = response.data;
        }).catch(error => {
            console.log(error);
        })
    };

    carregarAgendamentoResumo = async (id) => {
        try {
            let response = await this.service.listarAgendamentoResumo(id);
            if (response && response.data) {
                let listaAgendamentoResumo = response.data;
                await createPDFDetalhesAgendamento(listaAgendamentoResumo);
            }
        }
        catch (error) {
            console.log(error);
        };
    }

    carregarDATPorAgenda = (agendId) => {
        this.service.buscarDATPorAgenda(agendId).then(response => {
            if (response.data) {
                _.set(this.dadosAgendamento, "DAT.NumeroDAT", response.data.NumeroDAT);
                _.set(this.dadosAgendamento, "DAT.ArquivoDAT", response.data.ArquivoDAT);
                _.set(this.dadosAgendamento, "DAT.AgendamentoContemDAT", response.data.AgendamentoContemDAT);

            } else {
                _.set(this.dadosAgendamento, "DAT.NumeroDAT", null);
                _.set(this.dadosAgendamento, "DAT.ArquivoDAT", null);
                _.set(this.dadosAgendamento, "DAT.AgendamentoContemDAT", null);
            }
        }).catch(error => {
            _.set(this.dadosAgendamento, "DAT.NumeroDAT", null);
            _.set(this.dadosAgendamento, "DAT.ArquivoDAT", null);
            _.set(this.dadosAgendamento, "DAT.AgendamentoContemDAT", null);
        })
    };
    
    carregarMotoristaPorCNH = () => {
            this.atualiza = false;
            this.dadosAgendamento = _.omit(this.dadosAgendamento, "Motorista.Id");
            this.dadosAgendamento = _.omit(this.dadosAgendamento, "Motorista.CategCnh");
            this.dadosAgendamento = _.omit(this.dadosAgendamento, "Motorista.Cpf");
            this.dadosAgendamento = _.omit(this.dadosAgendamento, "Motorista.Nome");
            _.set(this.dadosAgendamento, `Motorista.MotoristaNome_Bloqueado`, true);
            _.set(this.dadosAgendamento, `Motorista.MotoristaCpf_Bloqueado`, true);
            _.set(this.dadosAgendamento, `Motorista.MotoristaCategCnh_Bloqueado`, true);
            this.atualiza = true;
            if (_.has(this.dadosAgendamento, 'Motorista.N4DriverLicense') && _.get(this.dadosAgendamento, 'Motorista.N4DriverLicense') && _.get(this.dadosAgendamento, 'Motorista.N4DriverLicense').length > 0) {
                this.service.buscarMotoristaPorCNH(_.get(this.dadosAgendamento, 'Motorista.N4DriverLicense')).then(response => {
                    if (response.data) {
                        console.log('data motorista', response.data)
                        this.atualiza = false;
                        _.set(this.dadosAgendamento, "Motorista.Id", response.data.Id);
                        _.set(this.dadosAgendamento, "Motorista.CategCnh", response.data.CategCnh);
                        console.log('categoria cnh', response.data.CategCnh);
                        this.bloqueiaCamposMotoristaCat = response.data.CategCnh ? true : false; 
                        _.set(this.dadosAgendamento, "Motorista.Cpf", response.data.N4CardId || response.data.Cpf);
                        this.bloqueiaCamposMotoristaCpf = response.data.N4CardId || response.data.Cpf ? true : false; 
                        _.set(this.dadosAgendamento, "Motorista.Nome", response.data.Nome);
                        this.bloqueiaCamposMotoristaNome = response.data.Nome ? true : false; 
                        if (!this.isEditar || this.tudoPronto) this.atualiza = true;
                        this.dadosMotoristaPronto = true;
                        this.liberaDadosMotorista(true);
                    } else {
                        this.liberaDadosMotorista();
                        this.bloqueiaCamposMotoristaCat = false;
                        this.bloqueiaCamposMotoristaNome = false;
                        this.bloqueiaCamposMotoristaCpf = false;
                    }
                }).catch(error => {
                    this.liberaDadosMotorista();
                    this.bloqueiaCamposMotoristaCat = false;
                    this.bloqueiaCamposMotoristaNome = false;
                    this.bloqueiaCamposMotoristaCpf = false;
                })
            } else {
                this.liberaDadosMotorista();
                this.bloqueiaCamposMotoristaCat = true;
                this.bloqueiaCamposMotoristaNome = true;
                this.bloqueiaCamposMotoristaCpf = true;
                // if(!_.has(this.dadosAgendamento, 'Motorista.N4DriverLicense')) {
                //     this.bloqueiaCamposMotoristaCat = true;
                //     this.bloqueiaCamposMotoristaNome = true;
                //     this.bloqueiaCamposMotoristaCpf = true;
                // }
            }
    };

    carregarNotasFiscaisPorAgendaId = (id) => {
        this.service.buscarNotasFiscaisPorAgenda(id).then(
            response => {
                if (response.data) {
                    _.set(this.dadosNotaFiscal, `listaNf`, response.data);
                    this.setNumTransId();
                    this.dadosNotasPronto = true;
                }
            }
        ).catch(
            erro => console.log(erro)
        )
    };

    setNumTransId = () => {
        this.dadosNotaFiscal.listaNf.map(item => { _.set(item, `NumNotaTransp`, _.get(item, 'Nf.NumNotaTransp')); });
    };

    liberaDadosMotorista = (liberaCamposEmBranco = false) => {
        this.atualiza = false;
        _.set(this.dadosAgendamento, `Motorista.MotoristaNome_Bloqueado`, liberaCamposEmBranco ? (_.get(this.dadosAgendamento, "Motorista.Nome")) : false);
        _.set(this.dadosAgendamento, `Motorista.MotoristaCpf_Bloqueado`, liberaCamposEmBranco ? (_.get(this.dadosAgendamento, "Motorista.Cpf")) : false);
        _.set(this.dadosAgendamento, `Motorista.MotoristaCategCnh_Bloqueado`, liberaCamposEmBranco ? (_.get(this.dadosAgendamento, "Motorista.CategCnh")) : false);
        setTimeout(function () {
            this.atualiza = true;
        }.bind(this), 1)
    };

    carregarTransportadoras = () => {
        //Ajuste no carregamento das transportadoras por conta do novo agendamento depot
        if (["DRE", 'DRED', 'DREDA', 'DDI'].indexOf(this.tipoAgendaAtivo.codIdentificador) !== -1) {
            this.service.listarTransportadorasPorMembershipDepot().then(response => {
                this.transportadoras = response.data;
            }).catch(error => {
                console.log(error);
            })
        } else if (['DREDD'].indexOf(this.tipoAgendaAtivo.codIdentificador) !== -1) {
            this.service.listarTransportadorasImportacaoDepot().then(response => {
                // response.data.map((item) => {
                //     let aux = [
                //         TranspId = item.CampoValue,
                //         ApelidoTransp =  item.CampoDescricao
                //     ]
                // })
                // console.log(aux)
                this.transportadoras = response.data;
            }).catch(error => {
                console.log(error);
            })
        }
        else {
            this.service.listarTransportadorasPorMembership().then(response => {
                this.transportadoras = response.data;
            }).catch(error => {
                console.log(error);
            })
        }
    };


    // carregarMotoristas = () => {
    //     //Ajuste no carregamento das transportadoras por conta do novo agendamento depot
    //   if (['DREDD'].indexOf(this.tipoAgendaAtivo.codIdentificador) !== -1) {
    //         this.service.listarMotoristaImportDepot().then(response => {
    //             this.motoristas = response.data;
    //             console.log('verificar2', this.dadosAgendamento)
    //         }).catch(error => {
    //             console.log(error);
    //         })       
    //   }
    // }


    carregarTransportadorasNotaFiscal = () => {
        this.service.listarTransportadorasNotaFiscal().then(response => {
            this.transportadorasNotaFiscal = response.data;
        }).catch(error => {
            console.log(error);
        })
    };

    carregarOperacoes = () => {
        if (this.tipoAgendaAtivo.value !== 0) {
            this.service.listarOperacoes(this.tipoAgendaAtivo.value, "flagtrem").then(response => {
                this.operacoes = response.data;
            }).catch(error => {
                console.log(error);
            })
        } else {
            this.operacoes = [];
        }
    };

    carregarListaDatas = () => {
        this.listaDatas = [];
        this.listaHoras = [];
        this.atualizaData = false;
        if (this.tipoAgendaAtivo.value !== 0) {
            this.service.listarDatas(this.tipoAgendaAtivo.value).then(response => {
            // this.service.listarDatas(285).then(response => {

                this.listaDatas = formatarListaDatas(response.data, "Dat");
                if (this.isEditar) this.carregarListaHoras(this.isEditar);
                setTimeout(function () {
                    this.atualizaData = true;
                }.bind(this), 1)
            }).catch(error => {
                console.log(error);
            })
        } else {
            this.listaDatas = [];
            this.atualizaData = true;
        }
    };

    carregarListaHoras = (isEditar = false) => {
        const dataAgend = _.get(this.dadosAgendamento, 'Agend.DatAgend')
        if (this.tipoAgendaAtivo.value !== 0 && dataAgend) {
            const dataAgendamento = moment(dataAgend)
            this.service.listarHoras(this.tipoAgendaAtivo.value, dataAgendamento.format("DD-MM-YYYY")).then(response => {
            // this.service.listarHoras(285, dataAgendamento.format("DD-MM-YYYY")).then(response => {

                const { data } = response
                if (isEditar && (moment().isSame(dataAgendamento, 'day'))) {
                    const horaAgend = _.get(this.dadosAgendamento, 'Agend.HoraAgend')
                    const horaMin = data[0].Hora
                    for (let size = horaMin - horaAgend - 1; size >= 0; size--) {
                        data.unshift({ 'Hora': horaAgend + size, 'FlgVaga': 'E' })
                    }
                }
                
                //Irá carregar os horários disponíveis baseado no deadline
                if (this.terminal === "RIG" && ['ECC', 'ECCM'].includes(this.tipoAgendaAtivo.codIdentificador)){
                    var horaLimite = 0;
                    let horaLimiteOld = 0;
                    if (_.has(this.dadosAgendamento, 'listaBookings')) {
                        this.dadosAgendamento.listaBookings.map(booking => {
                            const listaContainers = _.get(booking, 'containers');
                            if(listaContainers.length > 0){
                                listaContainers.map(container => { 
                                    this.ObterHoraLimiteAgendamento(container.CodCntr, booking.NumBooking, container.CdIso, dataAgendamento.format("DD-MM-YYYY")).then(response => {                                        
                                        if (response) {
                                            if(response === -1){
                                                this.listaHoras = formatarListaHoras(data);
                                            }
                                            else{
                                                this.listaHoras = formatarListaHorasDeadLine(data, response);
                                            }
                                        }
                                        else{
                                            this.listaHoras = formatarListaHoras(data);
                                        }
                                    })
                                });                
                            }
                            else{
                                this.listaHoras = formatarListaHoras(data);
                            }
                        });
                    }
                    else{              
                        this.listaHoras = formatarListaHoras(data);
                    }
                }
                else{                  
                    this.listaHoras = formatarListaHoras(data);
                }
                
            }).catch(error => {
                console.log(error);
            })
        } else {
            this.listaHoras = [];
        }
    };

    ObterHoraLimiteAgendamento = async (codCntr, numBkn, codIso, dataAgend) => {
       
        let { status, data } = await this.service.ObterHoraLimiteAgendamento(codCntr, numBkn, codIso, this.terminal, dataAgend, this.tipoAgendaAtivo.value);
       
        if(status == 200 && data){
            return data;
        }
    }

    setTerminalParaCamposObrigatorios = (terminal) => {
        this.terminalObrigatorios = terminal
    }

    carregaCamposObrigatorios = () => {
        this.camposObrigatorios = this.service.buscarCamposObrigatorios(this.tipoAgendaAtivo.codIdentificador, this.terminalObrigatorios);
        this.camposValidados = this.service.buscarCamposValidados(this.tipoAgendaAtivo.codIdentificador, this.terminalObrigatorios);
    };

    carregarDocumentosRetirada = (event) => {
        this.documentosRetirada = false;
        if (["RECBK", "RCDTC", "RCDICTAC", "RCDTA", "RCCRP"].indexOf(this.tipoAgendaAtivo.codIdentificador) !== -1) {
            if (event) {
                this.service.listarDocumentosRetirada(event.value, this.tipoAgendaAtivo.codTipo).then(response => {
                    if (response) {
                        this.documentosRetirada = response.data;
                    }
                })
            } else {
                this.documentosRetirada = false;
            }
        }
    };

    carregarComboboxesDocumentosRetirada = () => {
        this.documentosRetirada = [];
        let lista = _.get(this.dadosAgendamento, "listaBookings");
        let containers = []
        lista.map((book, x) => {
            this.documentosRetirada.push({ NumeroDi: _.get(book.containers[0], "DiRetirada") });
            _.set(this.dadosAgendamento, `listaBookings[${x}].ContainersDocumentos`, [{ Container: book.containers[0].CodCntr }]);
        });
    };

    carregarContainersDocumentosRetiradas = (dado, di) => {
        _.set(this.dadosAgendamento, `${dado}.ContainersDocumentos`, null);
        if (di)
            this.service.listarContainersRetirada(di.value).then(response => {
                if (response && response.data) {
                    _.set(this.dadosAgendamento, `${dado}.ContainersDocumentos`, response.data);
                } else {
                    this.dadosAgendamento = _.omit(this.dadosAgendamento, `${dado}.ContainersDocumentos`);
                }
                this.atualizaRetiradas = false;
                setTimeout(function () {
                    this.atualizaRetiradas = true;
                }.bind(this), 1)
            }).catch(erro => {
                console.log(erro)
            });
    };

    carregaCamposObrigatoriosNotasFiscais = (bagagemFlag = false) => {
        this.camposObrigatoriosNotas = this.service.buscarCamposObrigatoriosNotas(bagagemFlag);
    };

    mudaTipoAgenda(dados, AgendaAnterior = false) {
        //Se não for uma copia do agendamento anterior
        if (!AgendaAnterior)
            this.dadosAgendamento = {};

        this.dadosNotaFiscal = { listaNf: [] };
        if (dados !== null) {
            if (dados.value !== this.tipoAgendaAtivo.value) {
                this.tipoAgendaAtivo = dados;
                this.carregarOperacoes();
                this.carregarListaDatas();
                this.carregaCamposObrigatorios();
                this.carregarDocumentosRetirada();
            }
        } else {
            this.tipoAgendaAtivo = { value: -1, codIdentificador: "" };
        }
        this.filtraTipoAtual();
        this.setDadosAgendamento("Agend.TipoAgendId", dados);
    };

  carregaTipoAgendaPorId = (tipoAgendaId) => {
    this.service.buscarTipoAgendaPorId(tipoAgendaId).then((response) => {
      if (response.data) {
        this.selecionaTipoAgenda(response.data);
      } else {
        this.listaMensagens = response;
      }
    });
  }; 
  async carregarNotaPorAgendaId(tipoAgendaId) {
    try {
      const response = await this.service.carregarNotaPorAgenda(tipoAgendaId);
      if (response.data) {
        this.NotaFiscalNaoObrigatoria.NotaId = response.data.NotaId;
        this.preencherObjetoNotaFiscalNaoObrigatoria(response.data);
      }
    } catch (error) {
      // Tratar erros, se necessário
      console.error(error);
    }
  };
  async carregarArquivoPorNotaId(notaId) {
    if (notaId) {
      try {
        const response = await this.service.carregarArquivosPorNotaId(notaId);
        if (response.data) {
          response.data.map((c) => {
            this.objetoDeNotaFiscalNaoObrigatoria.fileNota.push(c);
          });
        }
      } catch (error) {
        // Tratar erros, se necessário
        console.error(error);
      }
    }
  }
  preencherObjetoNotaFiscalNaoObrigatoria = (nota) => {
    if (nota.IsCheckedVazioValue) {
      this.preencherisCheckedVazio(nota.IsCheckedVazioValue);
    }
    if (nota.IsCheckedBagagemValue) {
      this.preencherisCheckedBagagem(nota.IsCheckedBagagemValue);
    }
    if (nota.OutrosValue) {
      this.preencheroutros(nota.OutrosValue);
    }
    if (nota.ObservacoesValue) {
      this.preencherobservacoes(nota.ObservacoesValue);
    }
  };
  preencherisCheckedVazio = (vazioValue) => {
    if (vazioValue) {
      this.objetoDeNotaFiscalNaoObrigatoria.isCheckedVazio = true;
    }
  };

  preencherisCheckedBagagem = (bagagemValue) => {
    if (bagagemValue) {
      this.objetoDeNotaFiscalNaoObrigatoria.isCheckedBagagem = true;
    }
  };
 
  preencheroutros = (outroValue) => {
    if (outroValue) {
      this.objetoDeNotaFiscalNaoObrigatoria.outros = outroValue;
      this.NotaFiscalNaoObrigatoria.validarOutros = true;
      this.objetoDeNotaFiscalNaoObrigatoria.isCheckedOutros = true;
    }
  };
  preencherobservacoes = (observacoesValue) => {
    this.objetoDeNotaFiscalNaoObrigatoria.observacoes = observacoesValue;
  };
  selecionaTipoAgenda = (dadosTipoAgenda) => {
    this.tipoAgendaAtivo = {
      value: dadosTipoAgenda.Id,
      label: dadosTipoAgenda.DscTipo,
      codIdentificador: dadosTipoAgenda.CodIdentificador,
      codTipo: dadosTipoAgenda.codTipo,
    };
    this.carregarOperacoes();
    this.carregarListaDatas();
    this.carregaCamposObrigatorios();
    this.filtraTipoAtual();
  };

    filtraTipoAtual = () => {
        this.atualiza = false;
        this.atualizaBookings = false;
        this.atualizaRetiradas = false;
        this.atualizaDevolucoes = false;
        this.atualizaNotasFiscais = false;
        this.tipoAgendaRetirada = this.tiposAgendaRetirada.indexOf(this.tipoAgendaAtivo.codIdentificador);
        this.tipoAgendaEntrada = this.tiposAgendaEntrada.indexOf(this.tipoAgendaAtivo.codIdentificador);
        this.tipoAgendaDesistencia = this.tiposAgendaDesistencia.indexOf(this.tipoAgendaAtivo.codIdentificador);
        this.tipoAgendaRetiradaDepot = this.tiposAgendaRetiradaDepot.indexOf(this.tipoAgendaAtivo.codIdentificador);
        this.tipoAgendaRetiradaDepotDry = this.tiposAgendaRetiradaDepotDry.indexOf(this.tipoAgendaAtivo.codIdentificador);
        this.tipoAgendaRetiradaDevolucao = this.tiposAgendaRetiradaDevolucao.indexOf(this.tipoAgendaAtivo.codIdentificador);
        this.tipoAgendaRetiradaDepotDryAlimento = this.tiposAgendaRetiradaDepotDryAlimento.indexOf(this.tipoAgendaAtivo.codIdentificador);
        this.tipoEntradaImportacaoDepot = this.tiposEntradaImportacaoDepot.indexOf(this.tipoAgendaAtivo.codIdentificador);


        setTimeout(function () {
            this.atualiza = true;
            this.atualizaBookings = true;
            this.atualizaRetiradas = true;
            this.atualizaNotasFiscais = true;
        }.bind(this), 1)
    };

    mudaAbaEntrada = (index) => {
        if (this.abaEntradaAtiva !== index) {
            this.abaEntradaAtiva = index;
        }
    };

    verificaCamposComEspaco = (campo) => {
        if(this.dadosAgendamentoAceitaEspaco.includes(campo)) {
            return true;
        } else {
            if(this.dadosAgendamentoAceitaEspaco.find(c => campo.includes(c)) !== undefined) {
                return true;
            }
        }
        return false;
    }

    getDado(objeto, campo){
        return _.get(objeto, campo);
    }

    setDadosAgendamento = (campo, event) => {
        console.log('verificar', campo, event, this.dadosAgendamento)
        let valorCampo = null;
        if(event && event.target && typeof event.target.value === "string" && !this.verificaCamposComEspaco(campo) && event.target.value.includes(" ")) {
            valorCampo = event.target.value.replace(/\s/g,"");
        }

        if (event) {
            if (event.target) {
                if (event.target.value != "") {
                    if(!valorCampo) _.set(this.dadosAgendamento, campo, event.target.value);
                    else _.set(this.dadosAgendamento, campo, valorCampo);
                }
                else this.dadosAgendamento = _.omit(this.dadosAgendamento, campo);
            } else {
                _.set(this.dadosAgendamento, campo, event.value);
            }
        } else {
            this.dadosAgendamento = _.omit(this.dadosAgendamento, campo);
        }
    };

    
    dadoFoiSelecionado = (event) => {
        if (event) {
            if (event.target) {
                if (event.target.value != "") this.dadoDocumentoSelecionado = true;
                else this.dadoDocumentoSelecionado = false;
            } else this.dadoDocumentoSelecionado = true;
        } else this.dadoDocumentoSelecionado = false;
    };

    setDadosAgendamentoSemPensar = (campo, valor) => {
        _.set(this.dadosAgendamento, campo, valor);

    };
    formatarContainersSelecionado = () => {
    if (
      this.dadosNotaFiscal.listaNf &&
      this.dadosNotaFiscal.listaNf.length > 0
    ) {
      this.containersEdicao = [];
      if (this.isEditar) this.setContainersEdicao();
      this.dadosNotaFiscal.listaNf.map((nota, indexNota) => {
        if (_.get(nota, "ListaCntr")) {
          nota.ListaCntr.map((container, indexCntr) => {
            let index = this.listaContainersOptions.find(
              (item) => item.CodCntr === container.CodCntr
            );
            if (index) {
              let event = { label: container.CodCntr, value: index.Index };
              this.setCamposContainerNotaFiscalCarregada(
                event,
                indexCntr,
                indexNota,
                index.Index
              );
            }
          });
        }
        this.atualizarContainerNotasSelecionados(indexNota);
      });
    }
  };

    setHoraAgend = (event) => {
        this.setDadosAgendamento("Agend.HoraAgend", event);
        this.setDadosAgendamentoSemPensar("Agend.FlgGold", event.AgendGold);
    };

    //Essa função pode ser passada para inputs que possuem validadores
    //Da forma atual se um input estiver invalido ele não armazena o valor incorreto
    //Logo essa função seta uma variável indicando que há algum form invalido
    //De preferencia, essa função recebe um booleano
    setValidacao = (value) => {
        this.validado = value
    }

    setDadosNotaFiscal = (campo, event) => {
        // let valorCampo = null;
        // if(event && event.target && typeof event.target.value === "string" && !this.verificaCamposComEspaco(campo) && event.target.value.includes(" ")) {
        //     valorCampo = event.target.value.replace(/\s/g,"");
        // }
        if (event) {
            if (event.target) {
                if (event.target.value != "")  {
                    // if(!valorCampo) _.set(this.dadosNotaFiscal, campo, event.target.value);
                    // else _.set(this.dadosNotaFiscal, campo, valorCampo);
                    _.set(this.dadosNotaFiscal, campo, event.target.value);
                }
                else this.dadosNotaFiscal = _.omit(this.dadosNotaFiscal, campo)
            } else {
                _.set(this.dadosNotaFiscal, campo, event.value ? event.value : event)
            }
        } else {
            this.dadosNotaFiscal = _.omit(this.dadosNotaFiscal, campo)
        }
    
    };
    setAgendamentoListaNf = (novoAgendamento) => {
    var listaDeNf = [];
    this.dadosNotaFiscal.listaNf.map((nota) => {
      delete nota["CnpjDestinatario_lblNaoExiste"];
      delete nota["CnpjEmissor_lblNaoExiste"];
      delete nota["addManual"];
      _.set(
        nota,
        "Nf.InscrEstadDest",
        _.get(nota, "Nf.InscrEstadDest") ? _.get(nota, "Nf.InscrEstadDest") : ""
      );
      _.set(
        nota,
        "Nf.CnpjDest",
        _.get(nota, "Nf.CnpjDest") ? _.get(nota, "Nf.CnpjDest") : ""
      );
      _.set(
        nota,
        "Nf.CdUnidadeFedDest",
        _.get(nota, "Nf.CdUnidadeFedDest")
          ? _.get(nota, "Nf.CdUnidadeFedDest")
          : ""
      );
      _.set(
        nota,
        "Nf.NomCidadeDest",
        _.get(nota, "Nf.NomCidadeDest") ? _.get(nota, "Nf.NomCidadeDest") : ""
      );
      listaDeNf.push(nota);
    });
    _.set(novoAgendamento, `ListaNotaFiscalADE`, listaDeNf);
  };

    setDadosNotaFiscalSemPensar = (campo, valor) => {
        _.set(this.dadosNotaFiscal, campo, valor)
    };

    onBlurMotoristaCNH = () => {
        this.carregarMotoristaPorCNH();
    }

    adicionarNovo = () => {
        if (this.codigoNovo && this.codigoNovo.length > 0 || this.mostrarInserirNovo === "NOTAFISCAL_XML") {
            switch (this.mostrarInserirNovo) {
                case "BOOKING":
                    this.adicionarNovoBooking(); break;
                case "BOOKING OPCIONAL":
                    this.adicionarNovoBookingOpcional(); break;
                case "BOOKING_CONTAINER":
                    this.adicionarNovoBookingContainer(); break;
                case "NOTAFISCAL":
                    this.adicionarNovaNotaFiscal(); break;
                case "NOTAFISCAL_CONTAINER":
                    this.adicionarNovaNotaFiscalContainer(); break;
                case "NOTAFISCAL_NCM":
                    this.adicionarNovaNotaFiscalNCM(); break;
                case "NOTAFISCAL_XML":
                    this.adicionarXMLNotaFiscal(); break;
                default: break;
            }
        }
    }

    // Bookings
    abrirInserirNovoBooking = () => {
        this.carregarCamposPorNovoBookingOpcional();
    };

    // Entrada de Container Vazio - RIG
    abrirInserirNovoBookingOpcional = () => {
        this.carregarCamposPorNovoBookingOpcional();
    };

    adicionarNovoBooking = () => {
        this.carregarCamposPorNovoBooking();
        this.validarContainerBookingNotas();
    };

    adicionarNovoBookingOpcional = () => {
        this.carregarCamposPorNovoBookingOpcional();
        this.validarContainerBookingNotas();
    };

    handleBlurBooking = async (booking, pos) => {
        this.codigoNovo = booking;
        this.bookingBlur = true;
        this.blurStatus = true;
        await this.carregarCamposPorNovoBooking(pos);
    }

    carregarCamposPorNovoBooking = async (pos = null) => {
        this.inserindoEmModal = true;
        const ehEntradaVazio = ['ECV', 'ECVB'].includes(this.tipoAgendaAtivo.codIdentificador)
        const response = (this.terminal === "RIG" && !ehEntradaVazio) || this.terminal === "SSA" ? await this.service.buscarDadosPorBooking(this.codigoNovo) : null;
        try {
            var novoBooking = {};
            this.codigoBooking = this.codigoNovo;
            this.erroBookingTerminal = false;

            if (response && response.data && response.data.Cancelado == false) {
                novoBooking = {
                    NumBooking: this.codigoNovo,
                    containerAtivo: -1,
                    containers: [],
                    VesselvisitId: response.data.VesselvisitId,
                    IdViagemDtPrev: response.data.IdViagemDtPrev,
                    CdTipoCntr: response.data.TpocntCdTipoCntr,
                    ArmId: response.data.ArmId,
                    ApelidoArmador: response.data.ApelidoArmador,
                    CdPorto: response.data.CdPorto,
                    NomePorto: response.data.NomePorto,
                    LcCdLoc: response.data.Localidade,
                    bookingExistente: true,
                    collapsed: false,
                    dtRecebimento: !ehEntradaVazio ? response.data.InicioRecebimentoCheio : response.data.InicioRecebimentoVazio
                }
                this.codigoBooking = '';

                if (Object.entries(response).length) {
                    this.dadosMercadoria = {
                        umidade: response.data.Umidade,
                        ventilacao: response.data.Ventila,
                        temperatura: response.data.Temperatura,
                        un: response.data.Un
                    }
                }
                else {
                    this.dadosMercadoria = {};
                }

                if (!this.bookingBlur)
                    await this.inserirDadosBooking(novoBooking)
                else
                    await this.setCamposBookingExistente(novoBooking, pos)

                this.bookingBlur = false;
            }
            else if (response && response.data && response.data.Cancelado == true) {
                this.erroBookingTerminal = true;
                this.listaMensagens = ["Prezado cliente, o Booking informado está cancelado. Favor entrar em contato com o Armador."];
            }
            else {  //TODO Verificar se o terminal é SSA ou RIG (Se for SSA, mostrar modal com erro) 81834881
                if (this.terminal === "SSA") {
                    this.erroBookingTerminal = true;
                    this.listaMensagens = ["Booking não foi encontrado!"];
                    this.codigoNovo = "";
                } else {
                    if (ehEntradaVazio) return
                }

                novoBooking = {
                    NumBooking: this.codigoNovo,
                    containerAtivo: -1,
                    containers: [],
                    VesselvisitId: "",
                    IdViagemDtPrev: "",
                    CdTipoCntr: "",
                    ArmId: "",
                    ApelidoArmador: "",
                    CdPorto: "",
                    NomePorto: "",
                    LcCdLoc: "",
                    bookingExistente: false,
                    collapsed: false,
                    dtRecebimento: ""
                }

                this.dadosMercadoria = {};

                if (!this.bookingBlur)
                    this.inserirDadosBooking(novoBooking)
                else
                    this.setCamposBookingExistente(novoBooking, pos)

                this.bookingBlur = false;
            }

            if (!this.erroBookingTerminal)
                this.fecharModais();
        }
        catch (error) {
            console.log(error);
            this.inserindoEmModal = false;
        }
    };

    carregarCamposPorNovoBookingOpcional = () => {

        var novoBooking = {};
        this.codigoNovo = undefined;
        this.codigoBooking = this.codigoNovo;
        this.erroBookingTerminal = false;

        novoBooking = {
            NumBooking: this.codigoNovo,
            containerAtivo: -1,
            containers: [],
            VesselvisitId: "",
            IdViagemDtPrev: "",
            CdTipoCntr: "",
            ArmId: "",
            ApelidoArmador: "",
            CdPorto: "",
            NomePorto: "",
            LcCdLoc: "",
            bookingExistente: false,
            collapsed: false,
            dtRecebimento: ""
        }

        this.dadosMercadoria = {};
        this.collapseBookings(true);

        this.inserirDadosBooking(novoBooking);

    };

    inserirDadosBooking = (novoBooking) => {
        if (_.has(this.dadosAgendamento, 'listaBookings')) {
            this.dadosAgendamento.listaBookings.push(novoBooking);
        } else {
            this.atualizaBookings = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento, `listaBookings`, lista);
            this.dadosAgendamento.listaBookings.push(novoBooking);
            this.atualizaBookings = true;
        }
    };

    setCamposBookingExistente = (booking, pos) => {
        _.set(this.dadosAgendamento.listaBookings[pos], 'NumBooking', booking.NumBooking);
        _.set(this.dadosAgendamento.listaBookings[pos], 'VesselvisitId', booking.VesselvisitId);
        _.set(this.dadosAgendamento.listaBookings[pos], 'IdViagemDtPrev', booking.IdViagemDtPrev);
        _.set(this.dadosAgendamento.listaBookings[pos], 'CdTipoCntr', booking.CdTipoCntr);
        _.set(this.dadosAgendamento.listaBookings[pos], 'ArmId', booking.ArmId);
        _.set(this.dadosAgendamento.listaBookings[pos], 'ApelidoArmador', booking.ApelidoArmador);
        _.set(this.dadosAgendamento.listaBookings[pos], 'CdPorto', booking.CdPorto);
        _.set(this.dadosAgendamento.listaBookings[pos], 'NomePorto', booking.NomePorto);
        _.set(this.dadosAgendamento.listaBookings[pos], 'LcCdLoc', booking.LcCdLoc);
        _.set(this.dadosAgendamento.listaBookings[pos], 'bookingExistente', booking.bookingExistente);
        _.set(this.dadosAgendamento.listaBookings[pos], 'collapsed', booking.collapsed);
        _.set(this.dadosAgendamento.listaBookings[pos], 'dtRecebimento', booking.dtRecebimento);

        if (this.terminal === "SSA") {
            this.dadosAgendamento.listaBookings[pos].containers.map(container => {
                _.set(container, 'CdTipoCntr', null);
                _.set(container, 'CdIso', null);
                //Atualizar mercadoria dos cntrs
                _.set(container, 'ValTmpIdea', this.dadosMercadoria ? this.dadosMercadoria.temperatura : null);
                _.set(container, 'ValUmid', this.dadosMercadoria ? this.dadosMercadoria.umidade : null);
                _.set(container, 'ValVent', this.dadosMercadoria ? this.dadosMercadoria.ventilacao : null);
                _.set(container, 'IdUn', this.dadosMercadoria ? this.dadosMercadoria.un : null);
            });
        }

        this.blurStatus = false;
    }

    removerBooking = (index) => {
        this.dadosAgendamento.listaBookings.splice(index, 1);
        this.validarContainerBookingNotas();
    };

    duplicarBooking = (index) => {
        this.dadosAgendamento.listaBookings.push(this.dadosAgendamento.listaBookings.slice(index, 1)[0]);
    };

    // Containers de Booking
    abrirInserirNovoBookingContainer = (posBooking) => {
        this.posBookingNovoContainer = posBooking;
        this.carregarCamposPorBookingContainerOpcional(posBooking);
        this.validarContainerBookingNotas();
    };


    novoContainerDepotImportacao = (importacao) => {
        this.containerNovoImportacao = importacao;
        this.carregarCamposNovoContainerImportacao(importacao);
    };

    removeContainerEntradaImportacao = (index) => {
        console.log('index', index, this.dadosAgendamento);
        this.dadosAgendamento.Containeres.splice(index, 1);
        console.log('index2', index, this.dadosAgendamento);

    }

    checaContainerExiste(novoContainer) {

        let listaContainers = null;
        let result = false;

        if (_.has(this.dadosAgendamento, 'listaBookings')) {
            this.dadosAgendamento.listaBookings.map(booking => {
                listaContainers = _.get(booking, 'containers');
                listaContainers.map(container => {
                    if (container.CodCntr === novoContainer)
                        result = true;
                });
            });
        }


        return result;
    }

    adicionarNovoBookingContainer = () => {
        this.padraoDeCodigoInvalido = false;
        this.inserindoEmModal = true;
        this.codigoNovo = this.codigoNovo ? this.codigoNovo.toUpperCase() : this.codigoNovo;
        this.codigoBooking = this.codigoNovo;

        let containerExiste = this.checaContainerExiste(this.codigoNovo);

        if (!containerExiste) {
            if (!isInvalidoCodigoContainer(this.codigoNovo)) {
                this.carregarCamposPorBookingContainer();
            } else {
                this.inserindoEmModal = false;
                this.padraoDeCodigoInvalido = true;
            }
        }
        else {
            this.erroBookingTerminal = true;
            this.listaMensagens = ["Atenção: Container já existente no agendamento "];
        }
    };


    handleBlurContainer = async (posBooking, posContainer, container) => {
        this.containerBlur = true;
        this.padraoDeCodigoInvalido = false;
        this.codigoNovo = container;
        this.codigoBooking = this.codigoNovo;


        if (!isInvalidoCodigoContainer(this.codigoNovo)) {
            if (this.terminal === "RIG") {
                await this.carregarCamposPorBookingContainer(posBooking, posContainer);
            } else {
                this.carregarCamposPorBookingContainer(posBooking, posContainer);
            }

        } else {
            this.padraoDeCodigoInvalido = true;
        }
        await this.setDadosAgendamentoSemPensar(`listaBookings[${posBooking}].containers[${posContainer}].padraoContainer`, this.padraoDeCodigoInvalido);
        //await this.validarContainerBookingNotas();
    }

    adicionarNovoBookingContainerOpcional = () => {
        this.carregarCamposPorBookingContainerOpcional(this.posBookingNovoContainer);
        this.validarContainerBookingNotas();
    };


    carregarCamposNovoContainerImportacao = (importacao) => {
        let valid = { campo1: "", campo2: "", campo3: "" }

        this.codigoNovo = this.novoContainerBooking;

        var novoContainer = {
            campo1: this.codigoNovo,
            campo2: null,
            campo3: null,
        }

        this.inserirDadosNovoContainer(novoContainer);
    };


    carregarCamposPorBookingContainerOpcional = (posBooking) => {
        let valid = { CnpjCliente_lblNaoExiste: "", CnpjRespOva_lblNaoExiste: "", NCM_lblNaoExiste: "", ISO_lblNaoExiste: "", Umidade_Bloqueado: true }

        this.codigoNovo = this.novoContainerBooking;

        var novoContainer = {}

        if (this.terminal === "RIG") {
            novoContainer = {
                CodCntr: this.codigoNovo,
                ValTara: null,
                ValPesoMax: null,
                CdIso: null,
                ValPesoDoc: null,
                valid,
                Lacres: [],
                padraoContainer: false
            }
        } else {
            novoContainer = {
                CodCntr: this.codigoNovo,
                ValTara: null,
                ValPesoMax: null,
                CdIso: null,
                ValPesoDoc: null,
                valid,
                Lacres: [],
                padraoContainer: false,
                ValTmpIdea: this.dadosMercadoria ? this.dadosMercadoria.temperatura : null,
                ValUmid: this.dadosMercadoria ? this.dadosMercadoria.umidade : null,
                ValVent: this.dadosMercadoria ? this.dadosMercadoria.ventilacao : null,
                IdUn: this.dadosMercadoria ? this.dadosMercadoria.un : null
            }
        }

        this.inserirDadosBookingContainer(novoContainer);
    };

    collapseBookings = (bool, posBooking = null) => {
        if (this.dadosAgendamento.listaBookings != undefined &&
            this.dadosAgendamento.listaBookings != null &&
            this.dadosAgendamento.listaBookings.length > 0) {
            if (posBooking != null) {
                this.dadosAgendamento.listaBookings[posBooking].collapsed = bool;
            }
            else {
                this.dadosAgendamento.listaBookings.forEach(book => {
                    book.collapsed = bool;
                });
            }
        }
    }

    collapseNotaFiscal = (bool, posNF = null) => {
        if (this.dadosNotaFiscal.listaNf != undefined &&
            this.dadosNotaFiscal.listaNf != null &&
            this.dadosNotaFiscal.listaNf.length > 0) {
            if (posNF != null) {
                this.dadosNotaFiscal.listaNf[posNF].collapsed = bool;
            }
            else {
                this.dadosNotaFiscal.listaNf.forEach(nf => {
                    nf.collapsed = bool;
                });
            }
        }
    }

    carregarCamposPorBookingContainer = (posBooking, posContainer) => {
        if (this.codigoNovo != null || this.codigoNovo.length > 0) {
            this.service.buscarDadosPorContainer(this.codigoNovo).then(response => {
                this.codigoBooking = this.codigoNovo;
                if (response) {
                    let valid = { CnpjCliente_lblNaoExiste: "", CnpjRespOva_lblNaoExiste: "", NCM_lblNaoExiste: "", ISO_lblNaoExiste: "", Umidade_Bloqueado: true }

                    var novoContainer = {}

                    if (this.terminal === "RIG") {
                        novoContainer = {
                            CodCntr: this.codigoNovo,
                            //CdIso: response.data.Iso,
                            valid,
                            Lacres: [{ Id: 0, CdLacre: "ARM", Lacre: null, AgendCntrId: 0 }],
                            padraoContainer: false
                        }
                    } else {
                        novoContainer = {
                            CodCntr: this.codigoNovo,
                            ValTara: response.data.Tara,
                            ValPesoMax: response.data.Peso,
                            valid,
                            Lacres: [{ Id: 0, CdLacre: "ARM", Lacre: null, AgendCntrId: 0 }],
                            padraoContainer: false,
                            ValTmpIdea: this.dadosMercadoria ? this.dadosMercadoria.temperatura : null,
                            ValUmid: this.dadosMercadoria ? this.dadosMercadoria.umidade : null,
                            ValVent: this.dadosMercadoria ? this.dadosMercadoria.ventilacao : null,
                            IdUn: this.dadosMercadoria ? this.dadosMercadoria.un : null
                        }
                    }

                    if (!this.containerBlur)
                        this.inserirDadosBookingContainer(novoContainer)
                    else
                        this.setCamposBookingContainerExistente(posBooking, posContainer, novoContainer);

                    this.containerBlur = false;

                } else {
                    this.listaMensagens = response;
                }
            }).catch(error => {
                this.inserindoEmModal = false;
                this.containerBlur = false;
                console.log(error);
            })
        }
    };

    setCamposBookingContainerExistente = (posBooking, posContainer, containerObj) => {
        _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'CodCntr', containerObj.CodCntr);
        _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'valid', containerObj.valid);
        _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'Lacres', containerObj.Lacres);

        // REMOVIDO PARA O GO LIVE - MECANISMO SERÁ REFORMULADO
        // if (this.terminal === "RIG") {
        //     _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'CdIso', containerObj.CdIso);
        // } else {
        if (this.terminal === "SSA") {
            _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'ValTara', containerObj.ValTara);
            _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'ValPesoMax', containerObj.ValPesoMax);
            _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'ValTmpIdea', containerObj.ValTmpIdea);
            _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'ValUmid', containerObj.ValUmid);
            _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'ValVent', containerObj.ValVent);
            _.set(this.dadosAgendamento.listaBookings[posBooking].containers[posContainer], 'IdUn', containerObj.IdUn);
        }

    }

    inserirDadosBookingContainer = (novoContainer) => {
        if (_.has(this.dadosAgendamento.listaBookings[this.posBookingNovoContainer], 'containers')) {
            this.dadosAgendamento.listaBookings[this.posBookingNovoContainer].containers.push(novoContainer);
        } else {
            let lista = new observable([]);
            _.set(this.dadosAgendamento.listaBookings[this.posBookingNovoContainer], `containers`, lista);
            this.dadosAgendamento.listaBookings[this.posBookingNovoContainer].containers.push(novoContainer);
        }
        this.dadosAgendamento.listaBookings[this.posBookingNovoContainer].containerAtivo = this.dadosAgendamento.listaBookings[this.posBookingNovoContainer].containers.length - 1;

        this.setContainersOptions();
        this.fecharModais();
    };


    inserirDadosNovoContainer = (novoContainer) => {
        if (_.has(this.dadosAgendamento.containerImportacao[this.containerNovoImportacao], 'containers')) {
            this.dadosAgendamento.containerImportacao[this.containerNovoImportacao].containers.push(novoContainer);
        } else {
            let lista = new observable([]);
            _.set(this.dadosAgendamento.containerImportacao[this.containerNovoImportacao], `containers`, lista);
            this.dadosAgendamento.containerImportacao[this.containerNovoImportacao].containers.push(novoContainer);
        }
        this.dadosAgendamento.containerImportacao[this.containerNovoImportacao].containerAtivo = this.dadosAgendamento.listaBookings[this.containerNovoImportacao].containers.length - 1;

        this.setContainersOptions();
        this.fecharModais();
    };


    setContainersOptions = () => {
        this.containersOptions = [];
    };

    removerBookingContainer = (posBooking, index) => {
        let ctrnAtivo = (index === 0) ? 0 : index - 1;

        this.dadosAgendamento.listaBookings[posBooking].containers.splice(index, 1);
        this.setDadosAgendamentoSemPensar(`listaBookings[${posBooking}].containerAtivo`, ctrnAtivo);

        //this.removerNotaFiscalContainer(posBooking, index);
        this.validarContainerBookingNotas();
    };

    duplicarContainer = (posBooking, posContainer) => {
        this.dadosAgendamento.listaBookings[posBooking].containers.push(this.dadosAgendamento.listaBookings[posBooking].containers.slice(posContainer, 1)[0]);
    };

    // Lacres de Containers
    adicionarNovoBookingContainerLacre = (posBooking, posContainer) => {
        //Adiciono a verificação pois foi confirmado que o sistema do cliente só permite 4 lacres
        if (this.dadosAgendamento.listaBookings[posBooking].containers[posContainer].Lacres.length < 4) {
            if (this.dadosAgendamento.listaBookings[posBooking].containers[posContainer].Lacres.length === 0) {
                this.dadosAgendamento.listaBookings[posBooking].containers[posContainer].Lacres.push({ "Id": 0, "CdLacre": "ARM", "Lacre": null, "AgendCntrId": 0 });
            }
            else {
                this.dadosAgendamento.listaBookings[posBooking].containers[posContainer].Lacres.push({ "Id": 0, "CdLacre": null, "Lacre": null, "AgendCntrId": 0 });
            }
        }
    };

    setDadosLacre = (campo, event) => {
        if (event) {
            if (event.target) {
                _.set(this.dadosAgendamento, campo, (event.target.value.length > 0) ? event.target.value : null);
            } else {
                _.set(this.dadosAgendamento, campo, event.value);
            }
        } else {
            this.dadosAgendamento = _.set(this.dadosAgendamento, campo, null);
        }
    };

    setTransitoAduaneiro = () => {
        this.tranAduaneiro = !this.tranAduaneiro
        _.set(this.dadosAgendamento, "FlagTran", this.tranAduaneiro)
    }

    removerBookingContainerLacre = (posBooking, posContainer, index) => {
        this.atualizaLacres = false;
        this.dadosAgendamento.listaBookings[posBooking].containers[posContainer].Lacres.splice(index, 1);
        setTimeout(function () {
            this.atualizaLacres = true;
        }.bind(this), 1)
    };

    // Nota Fiscal
    abrirInserirNovaNotaFiscal = () => {
        this.adicionarNovaNotaFiscal();
    };

    abrirInserirXMLNotaFiscal = () => {
        this.mostrarInserirNovo = "NOTAFISCAL_XML"
    };

    inserirNotasAssociadas = async () => {
        try {
            this.loadNotasAssociadas = true;
            let buscarDados = [];
            // Montar lista para enviar ao serviço
            if (!arrayIsEmpty(this.dadosAgendamento.listaBookings)) {
                this.dadosAgendamento.listaBookings.map((bookAgend, x) => {
                    if (bookAgend.NumBooking && !arrayIsEmpty(bookAgend.containers)) {
                        bookAgend.containers.map(cntrAgend => {
                            buscarDados.push({ key: cntrAgend.CodCntr, value: bookAgend.NumBooking });
                        });
                    }
                });
            }

            //Executar o servico que irá trazer as Notas
            if (!arrayIsEmpty(buscarDados)) {
                let response = await this.service.ListarNotasPorCntrBooking(buscarDados);
                this.listaNotasAssociadas = response.data;
            }

            // Efetuando o loop e inserindo as Notas
            if (!arrayIsEmpty(this.listaNotasAssociadas)) {
                this.atualizaNotasFiscais = false;

                this.listaNotasAssociadas.map(nota => {
                    if (!arrayIsEmpty(this.dadosNotaFiscal.listaNf)) {
                        let notaExiste = false;
                        this.dadosNotaFiscal.listaNf.map(nf => {
                            if (nf.Nf && nf.Nf.Id) {
                                if (nf.Nf.Id === nota.Nf.Id && !notaExiste)
                                    notaExiste = true;
                            }
                        });
                        if (!notaExiste)
                            this.dadosNotaFiscal.listaNf.push(nota);
                    }
                    else {
                        this.dadosNotaFiscal.listaNf.push(nota);
                    }
                });
                setTimeout(function () {
                    this.atualizaNotasFiscais = true;
                }.bind(this), 1);
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            this.loadNotasAssociadas = false;
        }
    }

    adicionarNovaNotaFiscal = () => {
        this.codigoNovo = "";
        var nf = {
            Mensagem: null,
            Sucesso: true,
            NumNotaTransp: this.codigoNovo,
            Nf: {
                Id: 0,
                Status: "P",
                NumNotaTransp: null,
                SerieNotaTransp: "",
                DatEmissao: moment().toISOString(),
                TranspId: 0,
                DatSaidaEmissor: moment().toISOString(),
                ParcIdEmiss: 0,
                EstabIdEmiss: 0,
                CnpjDest: null,
                CdPaisDest: null,
                CdUnidadeFedDest: null,
                NomCidadeDest: null,
                InscrEstadDest: null,
                Operacao: 0,
                CodCfop: 0,
                ValIpi: 0,
                ValIcms: 0,
                QtdTotal: 0,
                ValTotal: 0,
                PesoTotal: 0,
                Cnpjs: null,
                Membershipuserid: 0,
                NumBooking: null,
                ChaveNfe: "",
                FlagBagagem: null,
                XmlNota: null,
                Ruc: null,
                StatusDue: null,
                TruckVisitAppointmentNbr: 0,
                FlagBitrem: null,
                RazaoSocialDest: "",
                RazaoSocialEmissor: ""
            },
            ListaCntr: [],
            ListaItem: [],
            CnpjDestinatario_lblNaoExiste: "", CnpjEmissor_lblNaoExiste: "", addManual: true,
            collapsed: false
        }

        this.collapseNotaFiscal(true);

        this.dadosNotaFiscal.listaNf.push(nf);
        let x = this.dadosNotaFiscal.listaNf.length - 1;
        this.dadosNotaFiscal.listaNf[x].NumNotaTransp = this.codigoNovo;
        this.dadosNotaFiscal.listaNf[x].Nf.NumNotaTransp = this.codigoNovo;

        if (typeof this.containersSelecionados[x] === 'undefined') this.containersSelecionados[x] = [];
        this.atualizaNotasFiscais = false;

        setTimeout(function () {
            this.atualizaNotasFiscais = true;
        }.bind(this), 1);

        this.fecharModais();
        this.validarContainerBookingNotas();
    };

    setCamposNotaComVal = (arr, val) => {
        if (arr && arr.length > 0) {
            arr.map(e => _.set(this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer], `Nf.${e}`, val));
        }
    };

    atualizaNotasContainer = () => {
        this.atualizaNotas = false;
        setTimeout(function () {
            this.atualizaNotas = true;
        }.bind(this), 1);
    }

    removerNotaFiscal = (index) => {
        this.dadosNotaFiscal.listaNf.splice(index, 1);
        this.validarContainerBookingNotas();
    };

    adicionarXMLNotaFiscal = () => {
        this.dadosNotaFiscal.listaNf.push(this.formatarJsonFile(this.jsonFile));
        this.containersSelecionados.push([{}]);
        this.fecharModais();
        this.validarContainerBookingNotas();
    };

    formatarJsonFile = (jsonFile) => {
        _.set(jsonFile, 'Nf', jsonFile.Nf);
        _.set(jsonFile, 'ListaCntr', jsonFile.ListaCntr ? jsonFile.ListaCntr : []);
        _.set(jsonFile, 'ListaItem', jsonFile.ListaItem ? jsonFile.ListaItem : []);
        return jsonFile;
    };

    guardaXMLNotaFiscal = (event) => {
        let xmlFileReader = new FileReader();
        this.xmlFileData = event.target.files[0];
        xmlFileReader.readAsText(this.xmlFileData);

        xmlFileReader.onload = () => {
            this.validandoXML = true;
            this.service.xmlImportNota(xmlFileReader.result)
                .then(response => {
                    if (response && response.data.Sucesso) {
                        this.jsonFile = {};
                        this.jsonFile.NumNotaTransp = _.get(response.data.Nf, 'NumNotaTransp');
                        this.jsonFile.Nf = response.data.Nf;
                        this.jsonFile.ListaCntr = response.data.ListaCntr;
                        this.jsonFile.ListaItem = response.data.ListaItem;
                        this.erroImportXML = false;
                    } else {
                        this.setErroImportXML(response.data.Mensagem);
                    }
                }).catch(err => { this.jsonFile = null; this.setErroImportXML("Falha ao carregar arquivo."); console.log(err); })
                .finally(() => this.validandoXML = false)
        }
    };

    setErroImportXML = (mensagem) => {
        this.erroImportXML = true;
        this.erroImportXMLMensagem = mensagem;
    };

    // Containers de Nota Fiscal
    abrirInserirNovoNotaFiscalContainer = (posNotaFiscal) => {
        // this.numContainerAnterior = receber; // Para quando criar editar, talvez ajude
        this.posNotaFiscalNovoContainer = posNotaFiscal;
        this.adicionarNovaNotaFiscalContainer();
    };

    adicionarNovaNotaFiscalContainer = () => {

        if (!_.has(this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer], 'ListaCntr')) {
            let lista = new observable([]);
            _.set(this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer], `ListaCntr`, lista);
        }

        let transpId = (this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer].Nf.Id > 0 ?
            this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer].Nf.Id : 0);

        this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer].ListaCntr.push({
            Id: 0,
            NotaFiscalTranspId: transpId,
            CntId: 0,
            CodCntr: '',
            Status: "P",
            NumGuiaCaminhao: null,
            NumBooking: '',
            UnitGkey: 0,
            StatusDue: null,
            IndExcluido: null,
            CnpjCobrade: 0,
            collapsed: false
        });

        if (this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer].Nf.length === 0) {
            this.setCamposNotaComVal(this.camposZerados, 0);
            this.setCamposNotaComVal(this.camposNulos, null);
            this.setCamposNotaComVal(["Status"], "P");
        }

        let novoContainer = this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer].ListaCntr.length - 1;
        this.containersSelecionados[this.posNotaFiscalNovoContainer][novoContainer] = {};

        this.atualizaNotasFiscaisContainer = false;
        setTimeout(function () {
            this.atualizaNotasFiscaisContainer = true;
        }.bind(this), 1);

        this.fecharModais();
        this.validarContainerBookingNotas();
    }

    removerNotaFiscalContainer = (pos, index) => {
        this.atualizaNotas = false;

        if (_.get(this.containersSelecionados[pos], [index])) {
            this.containersSelecionados[pos].splice(index, 1);
        }
        this.dadosNotaFiscal.listaNf[pos].ListaCntr.splice(index, 1);

        setTimeout(function () {
            this.atualizaNotas = true;
        }.bind(this), 1)
        this.validarContainerBookingNotas();
    };

    // NCM de Nota Fiscal
    abrirInserirNovoNotaFiscalNCM = (posNotaFiscal) => {
        this.posNotaFiscalNovoContainer = posNotaFiscal;
        this.adicionarNovaNotaFiscalNCM();
    };

    adicionarNovaNotaFiscalNCM = () => {
        if (_.has(this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer], 'ListaItem')) {
            this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer].ListaItem.push({
                Id: 0,
                NotaFiscalTranspId: 0,
                MercId: 0,
                QtdItem: 0,
                ValItem: 0,
                PesoItem: 0,
                NcmMerc: null,
                CodCfop: 0,
                IndExcluido: null,
                collapsed: false
            });
        } else {
            let lista = new observable([]);
            _.set(this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer], `ListaItem`, lista)
            this.dadosNotaFiscal.listaNf[this.posNotaFiscalNovoContainer].ListaItem.push({
                Id: 0,
                NotaFiscalTranspId: 0,
                MercId: 0,
                QtdItem: 0,
                ValItem: 0,
                PesoItem: 0,
                NcmMerc: null,
                CodCfop: 0,
                IndExcluido: null,
                collapsed: false
            });
        }
        this.fecharModais();
    };

    removerNotaFiscalNCM = (pos, index) => {
        this.atualizaNotas = false;
        this.dadosNotaFiscal.listaNf[pos].ListaItem.splice(index, 1);
        setTimeout(function () {
            this.atualizaNotas = true;
        }.bind(this), 1)
    };

    // Container Retirada
    adicionarRetirada = () => {
        if (_.has(this.dadosAgendamento, 'listaBookings')) {
            this.dadosAgendamento.listaBookings.push({ NumBooking: "", containerAtivo: -1, containers: [] });
        } else {
            this.atualizaRetiradas = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento, `listaBookings`, lista);
            this.dadosAgendamento.listaBookings.push({ NumBooking: "", containerAtivo: -1, containers: [] });
            this.atualizaRetiradas = true;
        }
        this.dadosAgendamento.listaBookings[this.dadosAgendamento.listaBookings.length - 1].containers.push({
            Lacres: []
        });
    };

    adicionarRetiradaVazioRig = () => {
        if (_.has(this.dadosAgendamento.listaBookings[0], 'containers')) {
            this.dadosAgendamento.listaBookings[0].containers.push({ containers: [] });
        } else {
            this.atualizaRetiradas = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento.listaBookings[0], `containers`, lista);
            this.dadosAgendamento.listaBookings[0].containers.push({ containers: [] });
            this.atualizaRetiradas = true;
        }
        this.dadosAgendamento.listaBookings[0].containerAtivo = this.dadosAgendamento.listaBookings[0].containers.length - 1;

    };

    adicionarRetiradaDepot = () => {
        if (_.has(this.dadosAgendamento.listaBookings[0], 'containers')) {
            this.dadosAgendamento.listaBookings[0].containers.push({ containers: [] });
        } else {
            this.atualizaRetiradas = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento.listaBookings[0], `containers`, lista);
            this.dadosAgendamento.listaBookings[0].containers.push({ containers: [] });
            this.atualizaRetiradas = true;
        }
        this.dadosAgendamento.listaBookings[0].containerAtivo = this.dadosAgendamento.listaBookings[0].containers.length - 1;

    };
    
    adicionarDevolucao = () => {
        if (!_.has(this.dadosAgendamento, 'listaBookings')) {
            this.atualizaDevolucoes = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento, `listaBookings`, lista);
            this.dadosAgendamento.listaBookings.push({ NumBooking: "", containerAtivo: -1, containers: [] });
            this.atualizaDevolucoes = true;
        }
        
        if (_.has(this.dadosAgendamento.listaBookings[0], 'containers')) {
            
            this.dadosAgendamento.listaBookings[0].containers.push({ CodCntr: "" });
        } else {
            
            this.atualizaDevolucoes = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento.listaBookings[0], `containers`, lista);
            this.dadosAgendamento.listaBookings[0].containers.push({ CodCntr: "" });
            this.atualizaDevolucoes = true;
        }
        this.dadosAgendamento.listaBookings[0].containerAtivo = this.dadosAgendamento.listaBookings[0].containers.length - 1;
    }

    copiarRetiradaDepot = (index) => {
        const data = this.dadosAgendamento.listaBookings[0].containers[index];
        this.dadosAgendamento.listaBookings[0].containers.push({
            CodCntr: data.CodCntr,
            CdTipoCntr: data.CdTipoCntr,
            VesselvisitId: data.VesselvisitId,
            ArmIdDepot: data.ArmIdDepot,
            CnpjCliente: data.CnpjCliente,
        });
        // this.dadosAgendamento.listaBookings[0].container = new observable([...this.dadosAgendamento.listaBookings[0].containers.slice(0,index),
        // {
        //     CodCntr: data.CodCntr,
        //     CdTipoCntr: data.CdTipoCntr,
        //     VesselvisitId: data.VesselvisitId,
        //     ArmIdDepot: data.ArmIdDepot,
        //     CnpjCliente: data.CnpjCliente, 
        // },
        // ...this.dadosAgendamento.listaBookings[0].containers.slice(index)]);

    };

    removerRetirada = (index) => {
        this.atualizaRetiradas = false;
        this.dadosAgendamento.listaBookings.splice(index, 1)
        setTimeout(function () {
            this.atualizaRetiradas = true;
        }.bind(this), 1)
    };
    
    removerRetiradaVazioRig = (index) => {
        this.atualizaRetiradas = false;
        this.dadosAgendamento.listaBookings[0].containers.splice(index, 1)
        setTimeout(function () {
            this.atualizaRetiradas = true;
        }.bind(this), 1)
    };

    removerRetiradaDepot = (index) => {
        this.atualizaRetiradas = false;
        this.dadosAgendamento.listaBookings[0].containers.splice(index, 1)
        setTimeout(function () {
            this.atualizaRetiradas = true;
        }.bind(this), 1)
    };

    // Container Desistencia
    adicionarDesistencia = () => {
        if (_.has(this.dadosAgendamento, 'listaBookings')) {
            this.dadosAgendamento.listaBookings.push({ NumBooking: "", containerAtivo: -1, containers: [] });
        } else {
            this.atualizaRetiradas = false;
            let lista = new observable([]);
            _.set(this.dadosAgendamento, `listaBookings`, lista);
            this.dadosAgendamento.listaBookings.push({ NumBooking: "", containerAtivo: -1, containers: [] });
            this.atualizaRetiradas = true;
        }
        this.dadosAgendamento.listaBookings[this.dadosAgendamento.listaBookings.length - 1].containers.push({
            Lacres: []
        });
    }

    // Geral
    modificarCodigoNovo = (event) => {
        this.codigoNovo = event.target.value ? event.target.value.toUpperCase() : event.target.value;
        this.codigoBooking = this.codigoNovo;
    };

    fecharModais = () => {
        this.mostrarInserirNovo = "";
        this.codigoNovo = "";
        this.codigoBooking = "";
        this.listaMensagens = false;
        this.inserindoEmModal = false;
        this.modalFimAgendamento = false;
        this.modalConfirmacaoCargaReefer = false;
        this.salvar = false;
    };

    fecharModaisErro = () => {
        this.listaMensagens = false;
        this.inserindoEmModal = false;
        this.modalFimAgendamento = false;
        this.erroBookingTerminal = false;
    };

    onClickFinalizarAgendamento = async () => {
        if (["C", "A", "V", "CI", "T"].includes(_.get(this.dadosAgendamento, "Agend.IndStatus"))) {
            this.listaMensagens = ["Só é possível editar agendamentos com status Agendado ou Incompleto"];
        } else {
            this.salvar = true;
            let novoAgendamento = { ListaContainer: [] };

            if(!["DREDD"].includes(this.tipoAgendaAtivo.codIdentificador)){
                this.setAgendamentoListaNf(novoAgendamento);
            }
            
            if (this.tipoAgendaAtivo && this.tipoAgendaAtivo.value > 0)
                _.set(novoAgendamento, "Agend.TipoAgendId", _.get(this.dadosAgendamento, "Agend.TipoAgendId") ? Number(_.get(this.dadosAgendamento, "Agend.TipoAgendId")) : 0);
            else { this.listaMensagens = ["Selecione o Tipo de agendamento"]; this.salvar = false; return false; }

            // VALIDADOR
            if (!_.find(this.camposObrigatorios, ['Agend.TranspId', true]) || _.get(this.dadosAgendamento, "Agend.TranspId") != null || _.get(this.dadosAgendamento, "Agend.TranspIdDepot") != null){
                _.set(novoAgendamento, "Agend.TranspId", _.get(this.dadosAgendamento, "Agend.TranspId") ? Number(_.get(this.dadosAgendamento, "Agend.TranspId")) : 0);
            } else { 
                this.listaMensagens = ["Favor preencher transportadora"]; this.salvar = false; return false; 
            }

            _.set(novoAgendamento, "Agend.IndStatus", _.get(this.dadosAgendamento, "Agend.IndStatus") || "P");
            _.set(novoAgendamento, "Agend.DatAgend", _.get(this.dadosAgendamento, "Agend.DatAgend"), null);

            if (_.get(this.dadosAgendamento, "Agend.HoraAgend") != null)
                _.set(novoAgendamento, "Agend.HoraAgend", _.get(this.dadosAgendamento, "Agend.HoraAgend"));
            else { this.listaMensagens = ["Favor preencher Data e Hora do agendamento"]; this.salvar = false; return false; }

            _.set(novoAgendamento, "Agend.Cnh", null);

            // VALIDADOR
            if (!_.find(this.camposObrigatorios, ['Agend.PlacaCavalo', true]) || _.get(this.dadosAgendamento, "Agend.PlacaCavalo") != null) _.set(novoAgendamento, "Agend.PlacaCavalo", _.get(this.dadosAgendamento, "Agend.PlacaCavalo"));
            else { this.listaMensagens = ["Favor preencher Placa cavalo"]; this.salvar = false; return false; }

            // VALIDADOR
            if (!_.find(this.camposObrigatorios, ['Agend.PlacaCarret1', true]) || _.get(this.dadosAgendamento, "Agend.PlacaCarret1") != null) _.set(novoAgendamento, "Agend.PlacaCarret1", _.get(this.dadosAgendamento, "Agend.PlacaCarret1", null));
            else { this.listaMensagens = ["Favor preencher Placa carreta 1"]; this.salvar = false; return false; }

            _.set(novoAgendamento, "DAT.AgendamentoContemDAT", _.get(this.dadosAgendamento, "DAT.AgendamentoContemDAT"));

            if(_.get(this.dadosAgendamento, "DAT.AgendamentoContemDAT")){
                if (_.get(this.dadosAgendamento, "DAT.NumeroDAT") != null) {
                    if (_.get(this.dadosAgendamento, "DAT.ArquivoDAT") == null) {
                        this.listaMensagens = ["Favor anexar um arquivo PDF para o DAT"];
                        this.salvar = false;
                        return false;
                    }
                    _.set(novoAgendamento, "DAT.NumeroDAT", _.get(this.dadosAgendamento, "DAT.NumeroDAT"));
                    _.set(novoAgendamento, "DAT.ArquivoDAT", _.get(this.dadosAgendamento, "DAT.ArquivoDAT"));             
                }
            }

            if (!this.validado) {
                this.listaMensagens = ["Algum campo está inválido. Por favor, verifique suas informações."]; this.salvar = false; return false;
            }

            //Caso não seja obrigatório ter placa cavalo e placa carreta e os dois forem null, eu seto para ainda aparecer no objeto a ser enviado
            if (!_.get(novoAgendamento, "Agend.PlacaCavalo", _.get(this.dadosAgendamento, "Agend.PlacaCavalo"))) _.set(novoAgendamento, "Agend.PlacaCavalo", null)
            if (!_.get(novoAgendamento, "Agend.PlacaCarret1", _.get(this.dadosAgendamento, "Agend.PlacaCarret1"))) _.set(novoAgendamento, "Agend.PlacaCarret1", null)

            _.set(novoAgendamento, "Agend.PlacaCarret2", _.get(this.dadosAgendamento, "Agend.PlacaCarret2", null));
            _.set(novoAgendamento, "Agend.MembershipuseridIncl", _.get(this.dadosAgendamento, "Agend.MembershipuseridIncl", 0));
            _.set(novoAgendamento, "Agend.DatIncl", _.get(this.dadosAgendamento, "Agend.DatIncl", null));
            _.set(novoAgendamento, "Agend.DatChegada", _.get(this.dadosAgendamento, "Agend.DatChegada", null));
            _.set(novoAgendamento, "Agend.FlgGold", _.get(this.dadosAgendamento, "Agend.FlgGold", "N"));
            _.set(novoAgendamento, "Agend.CdLoc", _.get(this.dadosAgendamento, "Agend.CdLoc", null));
            _.set(novoAgendamento, "Agend.DatAlt", _.get(this.dadosAgendamento, "Agend.DatAlt", null));
            _.set(novoAgendamento, "Agend.UsuAlt", _.get(this.dadosAgendamento, "Agend.UsuAlt", null));
            _.set(novoAgendamento, "Agend.OperTrem", _.get(this.dadosAgendamento, "Agend.OperTrem", null));
            _.set(novoAgendamento, "Agend.CodVagao", _.get(this.dadosAgendamento, "Agend.CodVagao", null));
            _.set(novoAgendamento, "Agend.DataLibEspec", _.get(this.dadosAgendamento, "Agend.DataLibEspec", null));
            _.set(novoAgendamento, "Agend.HoraLibEspec", _.get(this.dadosAgendamento, "Agend.HoraLibEspec", null));
            _.set(novoAgendamento, "Agend.DataAntesLib", _.get(this.dadosAgendamento, "Agend.DataAntesLib", null));
            _.set(novoAgendamento, "Agend.HoraAntesLib", _.get(this.dadosAgendamento, "Agend.HoraAntesLib", null));
            _.set(novoAgendamento, "Agend.DatUltimoNotify", _.get(this.dadosAgendamento, "Agend.DatUltimoNotify", null));
            _.set(novoAgendamento, "Agend.DriverName", _.get(this.dadosAgendamento, "Agend.DriverName", null));
            _.set(novoAgendamento, "Agend.DriverLicense", _.get(this.dadosAgendamento, "Agend.DriverLicense", null));
            _.set(novoAgendamento, "Agend.DriverCardId", _.get(this.dadosAgendamento, "Agend.DriverCardId", null));
            _.set(novoAgendamento, "Agend.DescIndStatus", _.get(this.dadosAgendamento, "Agend.DescIndStatus", null));

            _.set(novoAgendamento, "Motorista.Id", _.get(this.dadosAgendamento, "Motorista.Id", 0));
            _.set(novoAgendamento, "Motorista.CategCnh", _.get(this.dadosAgendamento, "Motorista.CategCnh", null));
            _.set(novoAgendamento, "Motorista.Cpf", _.get(this.dadosAgendamento, "Motorista.Cpf") ? Number(_.get(this.dadosAgendamento, "Motorista.Cpf")) : 0);
            _.set(novoAgendamento, "Motorista.Identidade", _.get(this.dadosAgendamento, "Motorista.Identidade", null));
            _.set(novoAgendamento, "Motorista.OrgEmissId", _.get(this.dadosAgendamento, "Motorista.OrgEmissId", null));
            _.set(novoAgendamento, "Motorista.Nome", _.get(this.dadosAgendamento, "Motorista.Nome", null));
            _.set(novoAgendamento, "Motorista.AgendMotoristaId", _.get(this.dadosAgendamento, "Motorista.AgendMotoristaId", null));
            _.set(novoAgendamento, "Motorista.N4DriverLicense", _.get(this.dadosAgendamento, "Motorista.N4DriverLicense", null));
            _.set(novoAgendamento, "Motorista.N4CardId", _.get(this.dadosAgendamento, "Motorista.Cpf", null));

            _.set(novoAgendamento, "ListaArquivos", _.get(this.dadosAgendamento, "ListaArquivos", null));
            //faz a rotina para inserir o agendamento de importacao

      if (!["DREDD"].includes(this.tipoAgendaAtivo.codIdentificador)) {
        if (
          this.dadosAgendamento.listaBookings &&
          this.dadosAgendamento.listaBookings.length > 0
        ) {
          var index = 0;
          this.dadosAgendamento.listaBookings.forEach((book) => {
            if (book.containers && book.containers.length > 0) {
              book.containers.forEach((cntr) => {
                novoAgendamento.ListaContainer.push({});
                if (
                  !this.setAgendamentoListaContainer(
                    novoAgendamento,
                    book,
                    cntr,
                    index
                  )
                ) {
                  this.salvar = false;
                  return false;
                }
                index++;
              });
            } else {
              this.listaMensagens = ["Não existem Containers"];
              this.salvar = false;
              return false;
            }
          });
        } else {
          this.listaMensagens = ["Não existem Bookings"];
          this.salvar = false;
          return false;
        }
        this.validarCamposNotaFiscalNaoObrigatoria();
        
        
         
      _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.NotaId",
        (this.NotaFiscalNaoObrigatoria && this.NotaFiscalNaoObrigatoria.NotaId) || null
    );
    
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.ObservacoesValue",
        (this.NotaFiscalNaoObrigatoria && this.NotaFiscalNaoObrigatoria.ObservacoesValue) || null
    );
    
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.OutrosValue",
        (this.NotaFiscalNaoObrigatoria && this.NotaFiscalNaoObrigatoria.OutrosValue) || null
    );
    
    _.set(
        novoAgendamento, 
        "NotaFiscalNaoObrigatoria.IsCheckedBagagemValue",
        (this.NotaFiscalNaoObrigatoria && this.NotaFiscalNaoObrigatoria.IsCheckedBagagemValue) || null
    );
    
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.IsCheckedVazioValue",
        (this.NotaFiscalNaoObrigatoria && this.NotaFiscalNaoObrigatoria.IsCheckedVazioValue) || null
    );
    
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.AgendaId",
        this.NotaFiscalNaoObrigatoria ? this.NotaFiscalNaoObrigatoria.AgendaId : null
    );
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.Email",
        this.NotaFiscalNaoObrigatoria ? this.NotaFiscalNaoObrigatoria.Email : null
    );
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.Booking",
        this.NotaFiscalNaoObrigatoria ? this.NotaFiscalNaoObrigatoria.Booking : null
    );
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.Navio",
        this.NotaFiscalNaoObrigatoria ? this.NotaFiscalNaoObrigatoria.Navio : null
    );
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.ContainerNotaNaoObrigatoria",
        this.NotaFiscalNaoObrigatoria ? this.NotaFiscalNaoObrigatoria.ContainerNotaNaoObrigatoria : null
    );
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.CnpjClienteNota",
        this.NotaFiscalNaoObrigatoria ? this.NotaFiscalNaoObrigatoria.CnpjClienteNota : null
    );
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.ChaveDeAcesso",
        "" // valor fixo
    );
    _.set(
        novoAgendamento,
        "NotaFiscalNaoObrigatoria.IdsDosArquivosReferenteAoAgendamento",
        this.NotaFiscalNaoObrigatoria ? this.NotaFiscalNaoObrigatoria.IdsDosArquivosReferenteAoAgendamento : null
    );


        const fileNotaArray = [...this.objetoDeNotaFiscalNaoObrigatoria.fileNota]; // ou .slice()
        _.set(
          novoAgendamento,
          "ArquivoNotaFiscalNaoObrigatoria.NomeDoArquivo",
          fileNotaArray.length > 0 ? fileNotaArray[0].NomeDoArquivo : null
        );
        
        _.set(
          novoAgendamento,
          "ArquivoNotaFiscalNaoObrigatoria.TipoArquivo",
          fileNotaArray.length > 0 ? fileNotaArray[0].TipoArquivo : null
        );
        
        _.set(
          novoAgendamento,
          "ArquivoNotaFiscalNaoObrigatoria.Arquivo",
          fileNotaArray.length > 0 ? fileNotaArray[0].Arquivo : null
        );
        
        
        _.set(
          novoAgendamento,
          "ArquivoNotaFiscalNaoObrigatoria.Version",
          1
        );
        _.set(
          novoAgendamento,
          "ArquivoNotaFiscalNaoObrigatoria.FileId",
          "00000000-0000-0000-0000-000000000000"
        );
        _.set(
          novoAgendamento,
          "ArquivoNotaFiscalNaoObrigatoria.NotaFiscalNaoObrigatoria_Id",
          "00000000-0000-0000-0000-000000000000"
        );
        
        if (this.isDepot) {
          _.set(novoAgendamento, "Agend.TranspId", -999); //precisa ser essa, por causa da FK do banco
          _.set(
            novoAgendamento,
            "Agend.TranspIdDepot",
            _.get(this.dadosAgendamento, "Agend.TranspIdDepot")
              ? Number(_.get(this.dadosAgendamento, "Agend.TranspIdDepot"))
              : null
          );
        } else {
          _.set(novoAgendamento, "Agend.TranspIdDepot", null);
        }

                _.set(novoAgendamento, "Agend.Id", (this.isEditar) ? _.get(this.dadosAgendamento, "Agend.Id") : 0);

                //TODO - APÓS TESTE, REMOVER VALIDAÇÃO
                if (this.validarCamposNotaFiscal()) {
                    this.setAgendamentoListaNf(novoAgendamento);
                } else {
                    return false;
                }

                //Valida se a categoria esta de acordo com o porto de destino final.
                if(novoAgendamento.ListaContainer.length > 0 && this.terminal === "RIG" && ["ECC","ECCM", "ECV","23ECV"].includes(this.tipoAgendaAtivo.codIdentificador)){
                    novoAgendamento.ListaContainer.forEach(unit =>{
                        if(unit.Categoria != null && unit.LcCdLoc != null){
                            if(unit.LcCdLoc.toUpperCase().substring(0,2) === "BR" && unit.Categoria === "E"){
                                this.listaMensagens = ["'Categoria' deve ser informado."]
                                this.salvar = false;
                            }
                            else if(unit.LcCdLoc.toUpperCase().substring(0,2) !== "BR" && unit.Categoria === "C"){
                                this.listaMensagens = ["'Categoria' deve ser informado."]
                                this.salvar = false;
                            }
                        }
                    });
                }
            }else{
                
                if (this.dadosAgendamento.Motorista == undefined) {
                    this.listaMensagens = ["Motorista é obrigatorio! Gentileza preencher."]; this.salvar = false; return false;   
                }

                if (this.dadosAgendamento.Motorista != undefined) {
                    // if (this.dadosAgendamento.Motorista.MotoristaCategCnh_Bloqueado == false || this.dadosAgendamento.Motorista.MotoristaCpf_Bloqueado == false || this.dadosAgendamento.Motorista.MotoristaNome_Bloqueado == false) {
                    //     this.listaMensagens = ["Motorista não encontrado na base de dados. Gentileza entrar em contato com a central de atendimento para cadastro."]; this.salvar = false; return false;   
                    // }        
                    if (this.dadosAgendamento.Motorista.CategCnh === null) {
                    this.listaMensagens = ["Campo Categoria é obrigatório, Gentileza preencher."]; this.salvar = false; return false;   
                    }
                }
                // if (this.dadosAgendamento.Agend.TranspId === -999) {
                //     console.log('entrou?')
                //     this.listaMensagens = ["Campo Transportadora é obrigatório, Gentileza preencher."]; this.salvar = false; return false;   
                // }
                if (this.dadosAgendamento.Containeres && this.dadosAgendamento.Containeres.length > 0) {
                    var index = 0;
                    this.dadosAgendamento.Containeres.forEach(cntr => 
                        {
                            if(cntr.importador === null || cntr.importador === undefined){
                                this.listaMensagens = ["Campo do importador/exportador é obrigatório, Gentileza preencher."]; this.salvar = false; return false;   
                            }
                            if(this.tipoCadastroImportacaoEntrada == "One")
                            {
                                console.log('container', cntr)
                                if(cntr.PlaceNm != "SALVADOR, BRAZIL"){
                                    this.listaMensagens = ["Impossivel Agendar um container que a localização não seja: SALVADOR, BRAZIL"]; this.salvar = false; return false; 
                                }
                            }
                        })
                        
                    this.dadosAgendamento.Containeres.forEach(cntr => 
                        {
                            novoAgendamento.ListaContainer.push({}); 
                            this.setAgendamentoImportacaoDepot(novoAgendamento, index, cntr)
                            index++
                        })
                 } else {
                    this.listaMensagens = ["Não existem Containers"]; this.salvar = false; return false;
                 }

                if (this.isDepot) {
                    _.set(novoAgendamento, "Agend.TranspIdDepot", _.get(this.dadosAgendamento, "Agend.TranspIdDepot") ? Number(_.get(this.dadosAgendamento, "Agend.TranspIdDepot")) : null);
                    _.set(novoAgendamento, "Agend.TranspId", -999); //precisa ser essa, por causa da FK do banco
                } else {
                    _.set(novoAgendamento, "Agend.TranspIdDepot", null);
                }
                _.set(novoAgendamento, "ListaNotaFiscalADE", []);
                _.set(novoAgendamento, "Agend.Id", (this.isEditar) ? _.get(this.dadosAgendamento, "Agend.Id") : 0);
                _.set(novoAgendamento, "isEditar", (this.isEditar) ? true : false);
            }

            // Verifica se há algum container refrigerado com carga seca e pede confirmação
                // Caso confirmado, irá chamar a função finalizarAgendamento()
                // Caso cancelado, o usuário voltará ao form
            if (this.salvar) {
                this.novoAgendamento = novoAgendamento;
                if(this.terminal === "RIG") {
                    let reefer = false
                    this.cdCntrReefer = [];
                    for( let i = 0; i < this.novoAgendamento.ListaContainer.length; i++){
                        if(this.novoAgendamento.ListaContainer[i].CdIso != null && this.novoAgendamento.ListaContainer[i].CdTipoMerc === 1 && ["ECC","ECCM"].includes(this.tipoAgendaAtivo.codIdentificador)) {
                            let response = await this.service.validarISO(this.novoAgendamento.ListaContainer[i].CdIso)
                                if(response.data.Refrigerado === "V") {
                                    this.cdCntrReefer.push(this.novoAgendamento.ListaContainer[i].CodCntr);
                                    reefer = true;
                                }
                        }
                    }
                    if (reefer) {
                        this.modalConfirmacaoCargaReefer = true;
                    } else {
                        this.finalizarAgendamento();
                    }
                } else {
                    this.finalizarAgendamento()
                }
            }
        }
    };

    finalizarAgendamento(){
        this.service.salvarAgendamento(this.novoAgendamento, this.isDepot).then(response => {
            this.salvar = false;
            if (response.data) {
                if (response.data.Sucesso) {
                    this.modalFimAgendamento = true;
                    this.resultadoFimAgendamento = response.data;
                } else {
                    let hum = (response.data.Mensagem) ? response.data.Mensagem : response.data;
                    this.listaMensagens = splitBR(hum);
                }
            } else {
                this.listaMensagens = ["Problemas ao salvar"]
            }
        }).catch(err => { console.log(err); });
    }

    setAgendamentoImportacaoDepot(novoAgendamento, index, cntr){
        _.set(novoAgendamento, `ListaContainer[${index}].CodCntr`, cntr.CodCntr);
        _.set(novoAgendamento, `ListaContainer[${index}].Import`, cntr.importador);
        _.set(novoAgendamento, `ListaContainer[${index}].Id`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].AgendId`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].NumBooking`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].NumCtrc`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].CdIso`, cntr.CodIso);
        _.set(novoAgendamento, `ListaContainer[${index}].CodIsoCodTipoCntr`, cntr.CodIsoCodTipoCntr);
        _.set(novoAgendamento, `ListaContainer[${index}].ArmId`,  cntr.ArmId);
        _.set(novoAgendamento, `ListaContainer[${index}].ValPesoMax`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].ValPesoDoc`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].ValTara`,null);
        _.set(novoAgendamento, `ListaContainer[${index}].ClibrsId`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].Categoria`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].MercId`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].IdCommoditie`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].CdTipoMerc`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].EadiId`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].CdPorto`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].LcCdLoc`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].Servicos`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ClibrsIdCons`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsDir`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsEsq`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsFre`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsTra`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsTop`,0);
        _.set(novoAgendamento, `ListaContainer[${index}].ValTmpIdea`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ValUmid`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ValVent`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].PrmcrgprgId`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].CdTipoMerc`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].IndPagtoTranAduan`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].FlgVistAduan`,null);
        _.set(novoAgendamento, `ListaContainer[${index}].NumDde`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].FlgNaoNota`, 'N');
        _.set(novoAgendamento, `ListaContainer[${index}].CodGenset`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ValPesoLiq`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].ClibrsIdCobrade`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].DepotId`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].VesselvisitId`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].IdUn`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].TrkVstApptNbr`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ApptNbr`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].IndStatus`, 'P');
        _.set(novoAgendamento, `ListaContainer[${index}].DiRetirada`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].QtdRetirada`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].FlgMapa`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].CntrStatus`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].FlgVgm`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].ObsVgm`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].Categoria`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].FlgTran`, 'N');
        _.set(novoAgendamento, `ListaContainer[${index}].FlgTranAduan`,  'N');
        _.set(novoAgendamento, `ListaContainer[${index}].FlgGensetAcoplado`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].CnpjRespOva`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].RazSocialRespOva`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].CnpjCliente`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].RazSocialCliente`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].FlatRack`, false); // PRECISA SER FALSO
        _.set(novoAgendamento, `ListaContainer[${index}].HouveAltBookingCntr`, false); // PRECISA SER FALSO
        _.set(novoAgendamento, `ListaContainer[${index}].ArmIdDepot`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].CliBrsIdDevolucao`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].CnpjClienteDevolucao`,  "");
        _.set(novoAgendamento, `ListaContainer[${index}].RazSocialDevolucao`, "");
        _.set(novoAgendamento, `ListaContainer[${index}].ClibrsIdDepot`, 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OperIdDepot`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].EnderecoEstufagemId`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].EnderecoLevanteId`,  0);
        _.set(novoAgendamento, `ListaContainer[${index}].DiId`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ShipmentNumber`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].Armador`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].IdViagemDtPrev`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].TipoAgendCodIdentificador`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ApelidoArmador`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].NomePorto`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].Operacao`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].Tipo`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ShipmentNumberObj`, null);           
        _.set(novoAgendamento, `ListaContainer[${index}].EnderecoEstufagem`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].EnderecoLevante`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].CdTipoCntr`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].Lacres`, null)  
        _.set(novoAgendamento, `ListaContainer[${index}].UNs`,  []);
        _.set(novoAgendamento, `ListaContainer[${index}].PreviaImportacaoDepot`,  cntr.PreviaImportacaoDepot);
        _.set(novoAgendamento, `ListaContainer[${index}].DatId`,  null);
     }


    validarCamposNotaFiscalNaoObrigatoria() {
    var objeto = this.objetoDeNotaFiscalNaoObrigatoria;
    var nota = this.NotaFiscalNaoObrigatoria;
    var agendamento = this.dadosAgendamento;

    if (objeto != null && this.notaFiscalNObrigatoria) {
        if (objeto.isCheckedBagagem) {
        nota.IsCheckedBagagemValue = "Bagagem";
        }

        if (objeto.isCheckedVazio) {
        nota.IsCheckedVazioValue = "Vazio";
        }

        if (objeto.observacoes) {
        nota.ObservacoesValue = objeto.observacoes;
        }

        if (objeto.outros && nota.validarOutros) {
        nota.OutrosValue = objeto.outros;
        }

        var emailCache = lscache.get("Email");
        if (emailCache) {
        nota.Email = emailCache;
        }

        if (this.ContainersNotaFiscalNaoObrigatoria &&
            agendamento &&
            agendamento.listaBookings &&
            Array.isArray(agendamento.listaBookings)) {
        nota.ContainerNotaNaoObrigatoria = agendamento.listaBookings
            .flatMap(function(booking) {
            return booking.containers
                ? booking.containers.map(function(container) {
                    return container.CodCntr ? container.CodCntr : "";
                })
                : [];
            })
            .join("");
        }

        if (agendamento &&
            agendamento.listaBookings &&
            agendamento.listaBookings.length > 0 &&
            agendamento.listaBookings[0].containers) {
        var cnpjs = agendamento.listaBookings.flatMap(function(booking) {
            return booking.containers
            ? booking.containers.map(function(container) {
                return container.CnpjCliente ? container.CnpjCliente : "";
                })
            : [];
        });
        nota.CnpjClienteNota = cnpjs.join(" ");
        }
    } else if (
        !this.notaFiscalNObrigatoria &&
        nota &&
        nota.IdsDosArquivosReferenteAoAgendamento &&
        nota.IdsDosArquivosReferenteAoAgendamento.length > 0
    ) {
        this.excluirArquivosPendentes(nota.IdsDosArquivosReferenteAoAgendamento);
    } else {
        this.NotaFiscalNaoObrigatoria = null;
    }
    }



    excluirArquivosPendentes = (IdsDosArquivos) => {
        if (IdsDosArquivos) {
        IdsDosArquivos.map((id, index) => {
            if (!id || id.length < 3) {
            IdsDosArquivos.splice(index, 1);
            }
        });
        IdsDosArquivos.map((id) => {
            try {
            return this.service
                .excluirDocumentoNotaNaoObrigatoria(id)
                .then((response) => {
                if (response) {
                    if (!response.data.Sucesso) {
                    console.log(response);
                    }
                } else {
                    console.log(
                    "Ocorreu um problema ao excluir o arquivo pendente" +
                        " " +
                        id
                    );
                }
                })
                .catch((error) => {
                console.log(error);
                });
            } catch (error) {
            console.log(error);
            }
        });
        }
    };



    setAgendamentoListaContainer(novoAgendamento, book, cntr, index) {
        // console.log(novoAgendamento)
        // console.log(cntr)
        // return 
        const agendamentoVazio = this.terminal === "RIG" && [142, 145].includes(_.get(this.dadosAgendamento, "Agend.TipoAgendId"));
        if(_.get(this.dadosAgendamento, "Agend.TipoAgendId") != 283)
        {
            this.isDepot = this.terminal === "SSA" && [282, 283, 284, 285].includes(_.get(this.dadosAgendamento, "Agend.TipoAgendId"));
        }
      
        _.set(novoAgendamento, `ListaContainer[${index}].Id`, _.get(cntr, "Id") ? Number(_.get(cntr, "Id")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].AgendId`, _.get(cntr, "AgendId") ? Number(_.get(cntr, "AgendId")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].CodCntr`, _.get(cntr, "CodCntr", null));

        // Ajustado para recuperar o NumBooking do cntr para caso de agendamentos vazios depot/rig, como foi feito para o campo ArmId
        if(agendamentoVazio || this.isDepot) {
            _.set(novoAgendamento, `ListaContainer[${index}].NumBooking`, _.get(cntr, "NumBooking", null));
        } else {
            _.set(novoAgendamento, `ListaContainer[${index}].NumBooking`, _.get(book, "NumBooking", null));
        }

        _.set(novoAgendamento, `ListaContainer[${index}].NumCtrc`, _.get(cntr, "NumCtrc", null));

        // VALIDADOR - TIPO CONTAINER
        if (this.terminal !== "SSA" || (!_.find(this.camposValidados, ['Booking.CdTipoCntr', true]) || _.get(cntr, "CdTipoCntr") != null))
            _.set(novoAgendamento, `ListaContainer[${index}].CdTipoCntr`, _.get(cntr, "CdTipoCntr", null));
        else {
            this.listaMensagens = [`Favor verificar Tipo de container em:`, `Booking: ${_.get(book, "NumBooking", "")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }       

        if(this.terminal === "SSA" && this.isDepot && ((_.get(cntr, `QtdRetirada`)) ? Number(_.get(cntr, `QtdRetirada`)) : 0) <= 0){
            this.listaMensagens = ["Campo Quantidade deve estar preenchido e com valor maior que zero."];
            this.salvar = false;
            return false;
        }

                // VALIDADOR - ARMADOR - ajustado para considerar que o ArmId já está no cntr no caso de retiradas de impo - RIG e retiradas de expo - DEPOT/SSA
                if (!_.find(this.camposValidados, ['Booking.ArmId', true]) || _.get(book, "ArmId") != null || _.get(cntr, "ArmId") != null)
                    _.set(novoAgendamento, `ListaContainer[${index}].ArmId`, ((agendamentoVazio || this.isDepot) && _.get(cntr, "ArmId")) ? Number(_.get(cntr, "ArmId")) : _.get(book, "ArmId") ? Number(_.get(book, "ArmId")) : 0);
                else {
                    this.listaMensagens = [`Favor verificar Armador em:`, `Booking: ${_.get(book, "NumBooking")}`];
                    this.salvar = false;
                    return false;
        }

        // VALIDADOR - ISO
        if (!_.find(this.camposValidados, ['Booking.Container.CdIso', true]) || _.get(cntr, "CdIso") != null)
            _.set(novoAgendamento, `ListaContainer[${index}].CdIso`, _.get(cntr, "CdIso", null));
        else {
            this.listaMensagens = [`Favor verificar ISO em:`, `Booking: ${_.get(book, "NumBooking")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }

        // VALIDADOR - CAPACIDADE MAXIMA
        if (!_.find(this.camposValidados, ['Booking.Container.ValPesoMax', true]) || (_.get(cntr, "ValPesoMax") != null && _.get(cntr, "ValPesoMax").toString().length === 5))
            _.set(novoAgendamento, `ListaContainer[${index}].ValPesoMax`, _.get(cntr, "ValPesoMax") ? Number(_.get(cntr, "ValPesoMax")) : 0);
        else {
            this.listaMensagens = [`Favor verificar Capacidade máxima em:`, `Booking: ${_.get(book, "NumBooking", "")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }

        // VALIDADOR - PESO DOCUMENTAL
        if (!_.find(this.camposValidados, ['Booking.Container.ValPesoDoc', true]) || (_.get(cntr, "ValPesoDoc") != null))
            _.set(novoAgendamento, `ListaContainer[${index}].ValPesoDoc`, _.get(cntr, "ValPesoDoc") ? Number(_.get(cntr, "ValPesoDoc")) : 0);
        else {
            this.listaMensagens = [`Favor verificar o Peso Documental em:`, `Booking: ${_.get(book, "NumBooking", "")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }

        // VALIDADOR - TARA
        if (!_.find(this.camposValidados, ['Booking.Container.ValTara', true]) || _.get(cntr, "ValTara") != null)
            _.set(novoAgendamento, `ListaContainer[${index}].ValTara`, _.get(cntr, "ValTara", null));
        else {
            this.listaMensagens = [`Validado - Favor verificar o Valor da Tara em:`, `Booking: ${_.get(book, "NumBooking")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }

        // VALIDADOR - CLIENTE
        if (!_.find(this.camposValidados, ['Booking.Container.ClibrsId', true]) || (_.get(cntr, "ClibrsId") != null && _.get(cntr, "ClibrsId") > 0))
            _.set(novoAgendamento, `ListaContainer[${index}].ClibrsId`, _.get(cntr, "ClibrsId") ? Number(_.get(cntr, "ClibrsId")) : 0);
        else {
            this.listaMensagens = [`Favor verificar Cliente em:`, `Booking: ${_.get(book, "NumBooking", "")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }

        // VALIDADOR - CATEGORIA
        if (!_.find(this.camposValidados, ['Booking.Container.Categoria', true]) || _.get(cntr, "Categoria") != null)
            _.set(novoAgendamento, `ListaContainer[${index}].Categoria`, _.get(cntr, "Categoria") ? Number(_.get(cntr, "Categoria")) : 0);
        else {
            this.listaMensagens = [`Favor verificar Categoria em:`, `Booking: ${_.get(book, "NumBooking", "")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }

        // VALIDADOR
        if (this.notaFiscalNObrigatoria) {
            if (_.get(cntr, "MercId") > 0){
                _.set(novoAgendamento, `ListaContainer[${index}].MercId`, _.get(cntr, "MercId"));
                _.set(novoAgendamento, `ListaContainer[${index}].IdCommoditie`, _.get(cntr, "MercId")); //SSA usa esse campo e precisa ser igual ao Merc Id
            }else {
                this.listaMensagens = [`Favor verificar NCM em:`, `Booking: ${_.get(book, "NumBooking")} - Container: ${_.get(cntr, "CodCntr")}`];
                this.salvar = false;
                return false;
            }
        } else {
            _.set(novoAgendamento, `ListaContainer[${index}].MercId`, 0);
            _.set(novoAgendamento, `ListaContainer[${index}].IdCommoditie`, null);
        }

        // VALIDADOR - CATEGORIA
        if (!_.find(this.camposValidados, ['Booking.Container.CdTipoMerc', true]) || (_.get(cntr, "CdTipoMerc") != null))
            _.set(novoAgendamento, `ListaContainer[${index}].CdTipoMerc`, _.get(cntr, "CdTipoMerc") ? Number(_.get(cntr, "CdTipoMerc")) : 0);
        else {
            this.listaMensagens = [`Favor verificar o Tipo de mercadoria em:`, `Booking: ${_.get(book, "NumBooking", "")} - Container: ${_.get(cntr, "CodCntr")}`];
            this.salvar = false;
            return false;
        }
        _.set(novoAgendamento, `ListaContainer[${index}].Orig`, _.get(cntr, `.Orig`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].EadiId`, _.get(cntr, `EadiId`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].CdPorto`, _.get(book, "CdPorto", null));
        _.set(novoAgendamento, `ListaContainer[${index}].LcCdLoc`, _.get(book, "LcCdLoc", null));
        _.set(novoAgendamento, `ListaContainer[${index}].Servicos`, _.get(book, "Servicos", null));
        _.set(novoAgendamento, `ListaContainer[${index}].ClibrsIdCons`, _.get(cntr, "ClibrsId") ? Number(_.get(cntr, "ClibrsId")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsDir`, _.get(cntr, "OverdmsDir") ? Number(_.get(cntr, "OverdmsDir")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsEsq`, _.get(cntr, "OverdmsEsq") ? Number(_.get(cntr, "OverdmsEsq")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsFre`, _.get(cntr, "OverdmsFre") ? Number(_.get(cntr, "OverdmsFre")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsTra`, _.get(cntr, "OverdmsTra") ? Number(_.get(cntr, "OverdmsTra")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OverdmsTop`, _.get(cntr, "OverdmsTop") ? Number(_.get(cntr, "OverdmsTop")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].ValTmpIdea`, _.get(cntr, `ValTmpIdea`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].ValUmid`, _.get(cntr, "ValUmid", null));
        _.set(novoAgendamento, `ListaContainer[${index}].ValVent`, _.get(cntr, "ValVent", null));
        _.set(novoAgendamento, `ListaContainer[${index}].PrmcrgprgId`, _.get(cntr, `PrmcrgprgId`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].CdTipoMerc`, _.get(cntr, "CdTipoMerc") ? Number(_.get(cntr, "CdTipoMerc")) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].IndPagtoTranAduan`, _.get(cntr, `IndPagtoTranAduan`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].FlgVistAduan`, _.get(cntr, `FlgVistAduan`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].NumDde`, _.get(cntr, `NumDde`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].FlgNaoNota`, this.notaFiscalNObrigatoria ? 'S' : 'N');
        _.set(novoAgendamento, `ListaContainer[${index}].CodGenset`, _.get(cntr, `CodGenset`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].ValPesoLiq`, _.get(cntr, `ValPesoLiq`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].ClibrsIdCobrade`, _.get(cntr, "ClibrsIdCobrade", 0));
        _.set(novoAgendamento, `ListaContainer[${index}].DepotId`, _.get(cntr, `DepotId`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].IdCommoditie`, _.get(cntr, `IdCommoditie`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].VesselvisitId`, ((agendamentoVazio || this.isDepot) && _.get(cntr, "VesselvisitId")) ? _.get(cntr, "VesselvisitId") : _.get(book, "VesselvisitId", null));
        _.set(novoAgendamento, `ListaContainer[${index}].IdUn`, _.get(cntr, `IdUn`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].TrkVstApptNbr`, _.get(cntr, `TrkVstApptNbr`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].ApptNbr`, _.get(cntr, `ApptNbr`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].IndStatus`, _.get(cntr, `IndStatus`, 'P'));
        _.set(novoAgendamento, `ListaContainer[${index}].DiRetirada`, _.get(cntr, `DiRetirada`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].QtdRetirada`, _.get(cntr, `QtdRetirada`) ? Number(_.get(cntr, `QtdRetirada`)) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].FlgMapa`, _.get(cntr, `FlgMapa`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].CntrStatus`, _.get(cntr, `CntrStatus`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].FlgVgm`, _.get(cntr, `FlgVgm`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].ObsVgm`, _.get(cntr, `ObsVgm`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].Categoria`, _.get(cntr, `Categoria`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].FlgTran`, _.get(cntr, `FlgTran`, 'N'));
        _.set(novoAgendamento, `ListaContainer[${index}].FlgTranAduan`, _.get(cntr, `FlgTranAduan`, 'N'));
        _.set(novoAgendamento, `ListaContainer[${index}].FlgGensetAcoplado`, _.get(cntr, `FlgGensetAcoplado`, null));
        _.set(novoAgendamento, `ListaContainer[${index}].CnpjRespOva`, _.get(cntr, "CnpjRespOva", null));
        _.set(novoAgendamento, `ListaContainer[${index}].RazSocialRespOva`, _.get(cntr, "RazSocialRespOva", null));
        _.set(novoAgendamento, `ListaContainer[${index}].CnpjCliente`, _.get(cntr, "CnpjCliente", null));
        _.set(novoAgendamento, `ListaContainer[${index}].RazSocialCliente`, _.get(cntr, "RazSocialCliente", null));
        _.set(novoAgendamento, `ListaContainer[${index}].FlatRack`, false); // PRECISA SER FALSO
        _.set(novoAgendamento, `ListaContainer[${index}].HouveAltBookingCntr`, false); // PRECISA SER FALSO
        _.set(novoAgendamento, `ListaContainer[${index}].ArmIdDepot`, _.get(cntr, `ArmIdDepot`) ? Number(_.get(cntr, `ArmIdDepot`)) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].CliBrsIdDevolucao`, _.get(cntr, "CliBrsIdDevolucao", 0));
        _.set(novoAgendamento, `ListaContainer[${index}].CnpjClienteDevolucao`, "");
        _.set(novoAgendamento, `ListaContainer[${index}].RazSocialDevolucao`, "");
        _.set(novoAgendamento, `ListaContainer[${index}].ClibrsIdDepot`, _.get(cntr, `ClibrsIdDepot`) ? Number(_.get(cntr, `ClibrsIdDepot`)) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].OperIdDepot`, _.get(cntr, `OperIdDepot`) ? Number(_.get(cntr, `OperIdDepot`)) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].EnderecoEstufagemId`, _.get(cntr, `EnderecoEstufagemId`) ? Number(_.get(cntr, `EnderecoEstufagemId`)) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].EnderecoLevanteId`, _.get(cntr, `EnderecoLevanteId`) ? Number(_.get(cntr, `EnderecoLevanteId`)) : 0);
        _.set(novoAgendamento, `ListaContainer[${index}].PreviaImportacaoDepot`,  null);
        _.set(novoAgendamento, `ListaContainer[${index}].Import`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].DatId`,  null);

        var tamLacres = 0;
        if (cntr.Lacres) {
            cntr.Lacres.map((lacre) => {
                if (lacre.Lacre == null) {
                    this.listaMensagens = [`Favor verificar o Lacre em:`, `Booking: ${_.get(book, "NumBooking", "")} - Container: ${_.get(cntr, "CodCntr")}`];
                    this.salvar = false;
                    return false;
                }
            })
            if (cntr.Lacres.length > 0 && cntr.Lacres[0].CdLacre) {
                _.set(novoAgendamento, `ListaContainer[${index}].Lacres[${tamLacres}]`, _.get(cntr, "Lacres[0]"));
                tamLacres++;
            }
            if (cntr.Lacres.length > 1 && cntr.Lacres[1].CdLacre) {
                _.set(novoAgendamento, `ListaContainer[${index}].Lacres[${tamLacres}]`, _.get(cntr, "Lacres[1]"));
                tamLacres++;
            }
            if (cntr.Lacres.length > 2 && cntr.Lacres[2].CdLacre) {
                _.set(novoAgendamento, `ListaContainer[${index}].Lacres[${tamLacres}]`, _.get(cntr, "Lacres[2]"));
                tamLacres++;
            }
            if (cntr.Lacres.length > 3 && cntr.Lacres[3].CdLacre) {
                _.set(novoAgendamento, `ListaContainer[${index}].Lacres[${tamLacres}]`, _.get(cntr, "Lacres[3]"));
                tamLacres++;
            } 
        }

        if (tamLacres == 0) _.set(novoAgendamento, `ListaContainer[${index}].Lacres`, null);

        if (_.get(cntr, "UNs") != null) {
            _.set(novoAgendamento, `ListaContainer[${index}].UNs`, [{ "Id": 0, "PrmcrgprgId": 0, "UnNa": 0, "AgendCntrId": 0 }]);
        } else {
            _.set(novoAgendamento, `ListaContainer[${index}].UNs`, [{ "Id": 0, "PrmcrgprgId": 0, "UnNa": 0, "AgendCntrId": 0 }]);
        }

        _.set(novoAgendamento, `ListaContainer[${index}].DiId`, _.get(cntr, `DiId`, null));

        _.set(novoAgendamento, `ListaContainer[${index}].ShipmentNumber`, _.get(cntr, `ShipmentNumber`, null));

        _.set(novoAgendamento, `ListaContainer[${index}].Armador`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].IdViagemDtPrev`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].TipoAgendCodIdentificador`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ApelidoArmador`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].NomePorto`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].Operacao`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].Tipo`, null);
        _.set(novoAgendamento, `ListaContainer[${index}].ShipmentNumberObj`, null);

        return true;
    }

    setAgendamentoListaNf = (novoAgendamento) => {
        var listaDeNf = [];
        this.dadosNotaFiscal.listaNf.map((nota) => {
            delete nota["CnpjDestinatario_lblNaoExiste"];
            delete nota["CnpjEmissor_lblNaoExiste"];
            delete nota["addManual"];
            _.set(nota, "Nf.InscrEstadDest", _.get(nota, "Nf.InscrEstadDest") ? _.get(nota, "Nf.InscrEstadDest") : "")
            _.set(nota, "Nf.CnpjDest", _.get(nota, "Nf.CnpjDest") ? _.get(nota, "Nf.CnpjDest") : "")
            _.set(nota, "Nf.CdUnidadeFedDest", _.get(nota, "Nf.CdUnidadeFedDest") ? _.get(nota, "Nf.CdUnidadeFedDest") : "")
            _.set(nota, "Nf.NomCidadeDest", _.get(nota, "Nf.NomCidadeDest") ? _.get(nota, "Nf.NomCidadeDest") : "")
            listaDeNf.push(nota);
        });
        _.set(novoAgendamento, `ListaNotaFiscalADE`, listaDeNf);
    };

    setTransportadorasNotaFiscal = (event) => {
        this.atualizaNotas = false;

        this.dadosNotaFiscal.listaNf.map((nota) => {
            if (event) {
                _.set(nota, "Nf.TranspId", event.value)
            }
        });

        setTimeout(function () {
            this.atualizaNotas = true;
        }.bind(this), 1)
    }

    validarCamposNotaFiscal = () => {
        /*if(this.dadosNotaFiscal.listaNf && this.dadosNotaFiscal.listaNf.length > 0) {
            this.dadosNotaFiscal.listaNf.map( (nota) => {
                if(_.get(nota,'Nf')){
                    this.carregaCamposObrigatoriosNotasFiscais(nota.Nf.FlagBagagem=='V');

                    let camposObrigatorios = this.camposObrigatoriosNotas.reverse();

                    camposObrigatorios.map( campoObrigatorio => {
                        if (!campoObrigatorio.flag) {
                            if(!nota.Nf.hasOwnProperty(campoObrigatorio.Cod)){
                                this.salvarMensagemErroNota(campoObrigatorio.Label, nota.NumNotaTransp);
                                this.salvar = false; return false;
                            }else if((_.get(nota.Nf , campoObrigatorio.Cod)===undefined)){
                                this.salvarMensagemErroNota(campoObrigatorio.Label, nota.NumNotaTransp);
                                this.salvar = false; return false;
                            }else if(_.get(nota.Nf , campoObrigatorio.Cod) === null || _.get(this.dadosNotaFiscal.Nf , campoObrigatorio.Cod) === ''){
                                this.salvarMensagemErroNota(campoObrigatorio.Label, nota.NumNotaTransp);
                                this.salvar = false; return false;
                            }
                        }
                    });
                }else{
                    this.listaMensagens = [`Preencha corretamente os campos da Nota ${nota.NumNotaTransp}`];
                    this.salvar = false; return false;
                }
            })
        }*/
        return true;
    };

    salvarMensagemErroNota = (campoLabel, notaNum) => {
        this.listaMensagens = [`Preencha o campo '${campoLabel}' da Nota ${notaNum}`]
    };

    setCamposContainerNotaFiscal = (event, pos, notaIndex, index) => {
        this.atualizaNotas = false;
        if (event) {
            let selecionado = this.listaContainersOptions.find(item => item.Index === event.value);

            this.setDadosNotaFiscalSemPensar(`${pos}.Index`, _.get(selecionado, `Index`));
            this.setDadosNotaFiscalSemPensar(`${pos}.CodCntr`, _.get(selecionado, `CodCntr`));
            this.setDadosNotaFiscalSemPensar(`${pos}.NumBooking`, _.get(selecionado, `NumBooking`));

            this.containersSelecionados[notaIndex][index] = { value: _.get(selecionado, `Index`), label: _.get(selecionado, `CodCntr`) };
        }

        setTimeout(function () {
            this.atualizaNotas = true;
        }.bind(this), 1)
    };

    setCamposContainerNotaFiscalCarregada = (event, pos, notaIndex, index) => {
        this.atualizaNotas = false;
        if (event) {
            if (typeof this.containersSelecionados[notaIndex] === 'undefined') this.containersSelecionados[notaIndex] = [];
            let selecionado = this.listaContainersOptions.find(item => item.Index === event.value);
            this.containersSelecionados[notaIndex].push({ value: _.get(selecionado, `Index`), label: _.get(selecionado, `CodCntr`) });
        }

        setTimeout(function () {
            this.atualizaNotas = true;
        }.bind(this), 1)
    };

    setContainersEdicao = () => {
        this.dadosNotaFiscal.listaNf.map((nota, indexNota) => {
            if (nota.ListaCntr && nota.ListaCntr.length > 0)
                this.containersEdicao.push({ notaIndice: indexNota, NotaFiscal: nota.NumNotaTransp, cntrIndex: 0, CodCntr: nota.ListaCntr[0].CodCntr })
        });
    }

    formatarContainersSelecionado = () => {
        if (this.dadosNotaFiscal.listaNf && this.dadosNotaFiscal.listaNf.length > 0) {
            this.containersEdicao = [];
            if (this.isEditar)
                this.setContainersEdicao();
            this.dadosNotaFiscal.listaNf.map((nota, indexNota) => {
                if (_.get(nota, 'ListaCntr')) {
                    nota.ListaCntr.map((container, indexCntr) => {

                        let index = this.listaContainersOptions.find(item => item.CodCntr === container.CodCntr);
                        if (index) {
                            let event = { 'label': container.CodCntr, 'value': index.Index };
                            this.setCamposContainerNotaFiscalCarregada(event, indexCntr, indexNota, index.Index);
                        }
                    })
                }
                this.atualizarContainerNotasSelecionados(indexNota);
            });
        }
    };

    atualizarContainerNotas = (pos) => {
        if (this.dadosNotaFiscal.listaNf && this.dadosNotaFiscal.listaNf.length > 0) {
            this.dadosNotaFiscal.listaNf.map((nota, indexNota) => {
                if (_.get(nota, 'ListaCntr')) {
                    nota.ListaCntr.map((container, indexCntr) => {
                        if (!this.isEditar) {
                            if (container.CodCntr != this.listaContainersOptions[indexCntr].CodCntr)
                                container.CodCntr = this.listaContainersOptions[indexCntr].CodCntr;
                        }
                        else {
                            if (this.containersEdicao[indexCntr].CodCntr != this.listaContainersOptions[indexCntr].CodCntr)
                                container.CodCntr = this.listaContainersOptions[indexCntr].CodCntr;
                        }

                    })
                }
            })
        }
    }

    atualizarContainerNotasSelecionados = (pos) => {
        if (_.get(this.dadosNotaFiscal.listaNf[pos], 'ListaCntr')) {
            this.containersSelecionados[pos] = [];
            this.dadosNotaFiscal.listaNf[pos].ListaCntr.map((container, indexCntr) => {
                this.containersSelecionados[pos].push({ value: indexCntr, label: container.CodCntr });
            });
        }
    }


    formatInserirNCMs = () => {
        this.dadosNotaFiscal.listaNf.map(nota => nota.ListaItem.map(item => {
            item['MercId'] = parseInt(item['NcmMerc']);
            item['Id'] = item['Id'] ? item['Id'] : 0;
            item['IndExcluido'] = item['IndExcluido'] ? item['IndExcluido'] : 'N';
            item['NotaFiscalTranspId'] = _.get(nota, `Nf.NotaFiscalTranspId`) ? _.get(nota, `Nf.NotaFiscalTranspId`) : 0;
        }));
    };

    formatInserirContainers = () => {
        this.dadosNotaFiscal.listaNf.map(nota => nota.ListaCntr.map(item => {
            item['Id'] = item['Id'] ? item['Id'] : 0;
            item['NumGuiaCaminhao'] = item['NumGuiaCaminhao'] ? item['NumGuiaCaminhao'] : 0;
            item['UnitGkey'] = item['UnitGkey'] ? item['UnitGkey'] : 0;
            item['Status'] = item['Status'] ? item['Status'] : "P";
            item['StatusDue'] = item['StatusDue'] ? item['StatusDue'] : null;
            item['CntId'] = item['CntId'] ? item['CntId'] : 0;
            item['CodCntr'] = item['CodCntr'] ? item['CodCntr'] : '';
            item['NumBooking'] = item['NumBooking'] ? item['NumBooking'] : '';
            item['IndExcluido'] = item['IndExcluido'] ? item['IndExcluido'] : 'N';
            item['NotaFiscalTranspId'] = _.get(nota, `Nf.NotaFiscalTranspId`) ? _.get(nota, `Nf.NotaFiscalTranspId`) : 0
        }));
    };

    formatCheckboxes = () => {
        //TODO: essa função não é chamada. se confirmado, remover.
        //this.dadosNotaFiscal.listaNf.map(nota => {
        //    _.set(nota,'Nf.FlagBitrem', _.get(nota,'Nf.FlagBitrem') ? 1 : null);
        //    _.set(nota,'Nf.FlagBagagem', _.get(nota,'Nf.FlagBagagem') ? 1 : null);
        //});
    };

    formatNotaParaEnviar = () => {
        this.notasFiscaisFormatadas = [];
        let notaTemp = {};
        this.dadosNotaFiscal.listaNf.map((nota, index) => {
            _.set(nota, 'Nf', _.get(nota.data, 'notaFiscal'));
            _.set(nota, 'ListaCntr', _.get(nota.data, 'containers') ? _.get(nota.data, 'containers') : []);
            _.set(nota, 'ListaItem', _.get(nota.data, 'items') ? _.get(nota.data, 'items') : []);

            this.notasFiscaisFormatadas.push(notaTemp);
        });
    }

    obterServicos = async (cnpj, cntr) => {
        
        let { status, data } = await this.service.obterServicos(cnpj, cntr);

        if(status == 200 && data){
            return data;
        }else{
            throw `Erro ao buscar cliente e os's: ${data}`;
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/stores/AgendamentoCadastrarStore.js